<template>
  <div>
    <Head />

    <nav class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
          <li class="breadcrumb-item active" aria-current="page" v-if="ApplyType == 1">外籍學位生</li>
          <li class="breadcrumb-item active" aria-current="page" v-if="ApplyType == 2">外籍交換生</li>
          <li class="breadcrumb-item active" aria-current="page" v-if="ApplyType == 3">出國交換生</li>
        </ol>
      </div>
    </nav>
    <div class="wrapper international_students_form_1 form exchange_student_form_1 out_exchange_form_1"
      v-if="ApplyInfoData">
      <a href="#AC" class="accesskey accesskey_c" title="中央內容區塊" accesskey="C" name="C">:::</a>
      <section class="container">
        <div class="">
          <h2 v-if="ApplyType == 1">
            外籍學位生 International Degree Student
          </h2>
          <h2 v-if="ApplyType == 2">
            外籍交換生 Incoming Exchange Students
          </h2>
          <h2 v-if="ApplyType == 3">
            出國交換生 Outgoing Exchange Students
          </h2>
          <p v-if="ApplyType == 1">
            National Taiwan University of Arts Online Application for International Degree Students
          </p>
          <p v-if="ApplyType == 2">
            National Taiwan University of Arts Application Form for Inbound Exchange and Visiting Students
          </p>
          <p v-if="ApplyType == 2" style="font-weight: 400;">
            大陸地區(中國)學生申請請使用繁體中文填寫
          </p>
          <p v-if="ApplyType == 3">
            National Taiwan University of Arts
          </p>
          <div v-show="Step == 0" v-html="ApplyInfoData.ApplyTypeInfo">
          </div>
          <div class="box review" v-show="Step == 3">
            <h4 style="color: red;">確認您的申請資料 Please Confirm Your Application Details</h4>
          </div>
          <!-- 基本資料區(Step3確認時也用同一畫面) -->
          <div class="btn_box" v-show="Step == 0">
            <button @click="gotoStep(1)">開始申請 Start Applying</button>
          </div>
          <div class="box review" v-if="Apply && (ApplyType == 1 || ApplyType == 2)" v-show="Step == 1 || Step == 3">
            <div class="form-group full">
              <Select2 class="form-control select2-control" v-model="Apply.Program" :options="ApplyData.Departments"
                :settings="{ placeholder: '請選擇申請系所' }" />
              <input type="text" class="form-control" :value="selectedText(Apply.Program, ApplyData.Departments)"
                v-show="Step == 3" disabled>
              <label class="Program" for=""><span><span class="required">*</span>選擇申請系所(只限申請一系)</span>Program (Please
                choose one program)</label>
            </div>
          </div>
          <div class="box review" v-if="Apply && (ApplyType == 1 || ApplyType == 2)" v-show="Step == 1 || Step == 3">
            <h2>申請人資料<span>Personal Information of Applicant</span></h2>
            <div class="personal_box">
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.Name" data-required="0"
                  data-required-msg="請填寫中文姓名" aria-describedby="" placeholder="請填寫中文姓名">
                <label for=""><span>中文姓名</span>Chinese Full Name</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.Name_EN" data-required="1"
                  data-required-msg="請填寫英文姓名" aria-describedby="" placeholder="請填寫英文姓名" @input="formatEnglishName">
                <label for=""><span><span class="required">*</span>英文姓名</span>English Full Name</label>
              </div>
              <div style="padding-left: 16px;">
                請依護照資料輸入，僅限輸入大寫英文字母（A–Z）及空白鍵。<br />
                Please enter the information exactly as shown on your passport.<br />
                Only uppercase English letters (A–Z) and spaces are allowed.
              </div>
              <div class="form-group">
                <date-picker class="form-control" v-model="Apply.Birthday" format="YYYY/MM/DD" value-type="format"
                  :input-attr="{ placeholder: '', 'data-required': '1', 'data-required-msg': '請填寫生日(西元年月日)' }"></date-picker>
                <input type="text" class="form-control" v-model="Apply.Birthday" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>生日(西元年月日)</span> Date of Birth</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.Gender" data-required="1" data-required-msg="請選擇性別">
                  <option value="-1" disabled selected>請選擇性別</option>
                  <option value="1">男</option>
                  <option value="2">女</option>
                  <option value="3">非二元</option>
                  <option value="4">其他</option>
                </select>
                <label for=""><span><span class="required">*</span>性別</span> Gender</label>
              </div>
            </div>
            <div class="file_box">
              <div class="custom_file">
                <input ref="upload" type="file" class="" accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg" id="Photo"
                  @change="previewFiles">
                <img id="Photo_preview" :src="Apply.Photo ? Apply.Photo : '#'"
                  :style="Apply.Photo ? 'opacity: 1;' : ''" />
                <div class="upload">選擇檔案 Choose file</div>
                <p>
                  <span><span class="required">*</span>上傳證件照 2-inch ID photo</span>
                  <br>
                  僅支援圖片且小於10MB以下的檔案
                </p>
                <input type="hidden" v-model="Apply.Photo" id="photo_data" data-required="1"
                  data-required-msg="請上傳證件照" />
              </div>
            </div>
            <div class="form-group" :class="ApplyType == 2 && Apply.Nationality == 'A00' ? 'full' : ''">
              <!-- <select class="form-control" v-model="Apply.Nationality" data-required="1" data-required-msg="請選擇國籍">
                <option value="" disabled selected>請選擇國籍</option>
                <option v-for="(Country, index) in ApplyData.Countrys" :key="index" :value="Country.Value">{{ Country.Text }}</option>
              </select> -->
              <Select2 class="form-control select2-control" v-model="Apply.Nationality" :options="ApplyData.Countrys"
                :settings="{ placeholder: '請選擇國籍' }" />
              <input type="text" class="form-control" :value="selectedText(Apply.Nationality, ApplyData.Countrys)"
                v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>國籍</span>Nationality</label>
              <div class="note china_note"
                :style="ApplyType == 2 && Apply.Nationality == 'A00' ? 'display: block;' : ''">
                <ul class="rule">
                  <li>依臺灣地區與大陸地區人民關係條例第七十七條規定：「大陸地區人民在臺灣地區以外之地區，犯內亂罪、外患罪，經許可進入臺灣地區，而於申請時據實申報者，免予追訴、處罰。」
                  </li>
                  <li>本申請書由申請人或代申請人親自據實填寫，如未據實填寫經查獲者，得撤銷其入境許可，並限期離境。</li>
                  <li>申請人來台期間應遵守中華民國法令，並依限離臺，且不得從事與許可目的不符之活動。</li>
                  <li>此申請表僅接受繁體字填寫</li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.PassportNumber"
                :data-required="Apply.Nationality == 'A00' ? '0' : '1'" data-required-msg="請填寫護照號碼" aria-describedby=""
                placeholder="請填寫護照號碼">
              <label for=""><span><span class="required" v-show="Apply.Nationality != 'A00'">*</span>護照號碼</span>Passport
                Number (大陸地區(中國)可免填)</label>
            </div>
            <div class="form-group china_note"
              :style="ApplyType == 2 && Apply.Nationality == 'A00' ? 'display: block;' : ''"></div>
            <div class="form-group">
              <vue-tel-input ref="Phone" class="form-control phone-control" v-model="Apply.Phone"
                :mode="'international'" :defaultCountry="phoneDefaultCountry"
                :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                :inputOptions="{ placeholder: '請填寫電話' }" autocomplete="new-phone"></vue-tel-input>
              <input type="text" class="form-control" v-model="Apply.Phone" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>電話(加國碼)</span>Phone Number</label>
            </div>
            <div class="form-group">
              <input type="email" class="form-control" v-model="Apply.Email" data-required="1"
                data-required-msg="請填寫電子郵件" aria-describedby="" placeholder="請填寫電子郵件">
              <label for=""><span><span class="required">*</span>電子郵件</span>Email</label>
            </div>
            <div class="form-group full">
              <input type="text" class="form-control" v-model="Apply.Address" data-required="1"
                data-required-msg="請填寫居住地址" aria-describedby="" placeholder="請填寫居住地址">
              <label for=""><span><span class="required">*</span>居住地址</span>Address</label>
            </div>
          </div>
          <div class="box review" v-if="Apply && (ApplyType == 1 || ApplyType == 2)" v-show="Step == 1 || Step == 3">
            <h2>緊急聯絡人<span>Emergency Contact Person</span></h2>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.EmergencyName" data-required="1"
                data-required-msg="請填寫姓名" aria-describedby="" placeholder="請填寫姓名">
              <label for=""><span><span class="required">*</span>姓名</span>Full Name</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.EmergencyRelation" data-required="1"
                data-required-msg="請填寫關係" aria-describedby="" placeholder="請填寫關係">
              <label for=""><span><span class="required">*</span>關係</span>Relation</label>
            </div>
            <div class="form-group">
              <vue-tel-input ref="EmergencyPhone" class="form-control phone-control" v-model="Apply.EmergencyPhone"
                :mode="'international'" :defaultCountry="phoneDefaultCountry"
                :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                :inputOptions="{ placeholder: '請填寫電話' }" autocomplete="new-phone"></vue-tel-input>
              <input type="text" class="form-control" v-model="Apply.EmergencyPhone" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>電話(加國碼)</span>Phone Number</label>
            </div>
            <div class="form-group">
            </div>
            <!-- <div class="form-group">
              <input type="email" class="form-control" v-model="Apply.EmergencyEmail" data-required="1"
                data-required-msg="請填寫電子郵件" aria-describedby="" placeholder="請填寫電子郵件">
              <label for=""><span><span class="required">*</span>電子郵件</span>Email</label>
            </div> -->
          </div>
          <div class="box review" v-if="Apply && ApplyType == 1" v-show="Step == 1 || Step == 3">
            <h2>家庭資料<span>Parents Information</span></h2>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_ParentsFatherName"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫父親姓名" aria-describedby=""
                placeholder="請填寫父親姓名">
              <label for=""><span><span class="required">*</span>父親姓名</span>Full Name of Applicant's Father</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_ParentsFatherNationality"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫父親國籍" aria-describedby=""
                placeholder="請填寫父親國籍">
              <label for=""><span><span class="required">*</span>父親國籍</span>Nationality of Applicant's Father</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_ParentsMotherName"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫母親姓名" aria-describedby=""
                placeholder="請填寫母親姓名">
              <label for=""><span><span class="required">*</span>母親姓名</span>Full Name of Applicant's Mother</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_ParentsMotherNationality"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫母親國籍" aria-describedby=""
                placeholder="請填寫母親國籍">
              <label for=""><span><span class="required">*</span>母親國籍</span>Nationality of Applicant's Mother</label>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 1" v-show="Step == 1 || Step == 3">
            <h2>最高學歷<span>Education Level</span></h2>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T1_EducationLeve" :data-required="ApplyType == 1 ? '1' : '0'"
                data-required-msg="請選擇學歷">
                <option value="" disabled selected>請選擇學歷</option>
                <option value="中學">中學</option>
                <option value="學士">學士</option>
                <option value="碩士">碩士</option>
                <option value="博士">博士</option>
              </select>
              <label for=""><span><span class="required">*</span>學歷</span>Education Leve</label>
            </div>
            <div class="form-group">
              <Select2 class="form-control select2-control" v-model="Apply.T1_CountryOfSchool"
                :options="ApplyData.Countrys" :settings="{ placeholder: '請選擇學校國家' }" />
              <input type="text" class="form-control"
                :value="selectedText(Apply.T1_CountryOfSchool, ApplyData.Countrys)" v-show="Step == 3" disabled>
              <!-- <select class="form-control" v-model="Apply.T1_CountryOfSchool" :data-required="ApplyType == 1 ? '1' : '0'"
                data-required-msg="請選擇學校國家">
                <option value="" disabled selected>請選擇學校國家</option>
                <option v-for="(Country, index) in ApplyData.Countrys" :key="index" :value="Country.Value">{{ Country.Text
                }}</option>
              </select> -->
              <label for=""><span><span class="required">*</span>學校國家</span>Country of School/Institute</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_SchoolName"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫學校名稱(中文)" aria-describedby=""
                placeholder="請填寫學校名稱(中文)">
              <label for=""><span><span class="required">*</span>學校名稱(中文)</span>School/Institute Name in Chinese</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_SchoolName_EN"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫學校名稱(英文)" aria-describedby=""
                placeholder="請填寫學校名稱(英文)">
              <label for=""><span><span class="required">*</span>學校名稱(英文) </span>School/Institute Name in
                English</label>
            </div>
            <div class="form-group month_box">
              <!-- <div class=""> -->
              <date-picker type="month" class="form-control" v-model="Apply.T1_StudyDurationStart" format="YYYY/MM"
                value-type="format"
                :input-attr="{ placeholder: '', 'data-required': ApplyType == 1 ? '1' : '0', 'data-required-msg': '請填寫就學期間(起)' }"></date-picker>
              <input type="text" class="form-control" v-model="Apply.T1_StudyDurationStart" v-show="Step == 3" disabled>
              <date-picker type="month" class="form-control" v-model="Apply.T1_StudyDurationEnd" format="YYYY/MM"
                value-type="format"
                :input-attr="{ placeholder: '', 'data-required': ApplyType == 1 ? '1' : '0', 'data-required-msg': '請填寫學就學期間(迄)' }"></date-picker>
              <input type="text" class="form-control" v-model="Apply.T1_StudyDurationEnd" v-show="Step == 3" disabled>
              <!-- </div> -->
              <label for=""><span><span class="required">*</span>就學期間</span>Study Duration</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T1_Department"
                :data-required="ApplyType == 1 ? '1' : '0'" data-required-msg="請填寫系所/主修" aria-describedby=""
                placeholder="請填寫系所/主修">
              <label for=""><span><span class="required">*</span>系所/主修</span>Department/ Major</label>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 2" v-show="Step == 1 || Step == 3">
            <h2>在學狀況<span>Education Information</span></h2>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T2_SchoolContinent"
                :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇目前就讀學校地區">
                <option value="" disabled selected>請選擇目前就讀學校地區</option>
                <option value="亞洲">亞洲(Asia)</option>
                <option value="歐洲">歐洲(Europe)</option>
                <option value="大洋洲">大洋洲(Oceania)</option>
                <option value="美洲">美洲(America)</option>
              </select>
              <label for=""><span><span class="required">*</span>目前就讀學校地區</span>Current School Continent</label>
            </div>
            <div class="form-group">
              <Select2 class="form-control select2-control" v-model="Apply.T2_SchoolCountry"
                :options="filteredContinentCountry" :settings="{ placeholder: '請選擇目前就讀學校國別' }" />
              <input type="text" class="form-control" :value="selectedText(Apply.T2_SchoolCountry, ApplyData.Countrys)"
                v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>目前就讀學校國別</span>Current School Nationality</label>
            </div>
            <div class="form-group full">
              <Select2 class="form-control select2-control" v-model="Apply.T2_SchoolName"
                :options="filteredContractSchools" :settings="{ placeholder: '請選擇目前就讀學校' }" />
              <input type="text" class="form-control" :value="Apply.T2_SchoolName" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>目前就讀學校</span>Current School Name</label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T2_SchoolProgram" :data-required="ApplyType == 2 ? '1' : '0'"
                data-required-msg="請選擇學制">
                <option value="" disabled selected>請選擇學制</option>
                <option value="大學部">大學部 BA Program</option>
                <option value="碩士班">碩士班 MA Program</option>
                <option value="博士班">博士班 PhD Program</option>
              </select>
              <label for=""><span><span class="required">*</span>目前就讀學制</span>Current Program</label>
            </div>
            <div class="form-group">
              <input type="" class="form-control" v-model="Apply.T2_Department"
                :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請填寫系所" aria-describedby=""
                placeholder="請填寫系所">
              <label for=""><span><span class="required">*</span>系所</span>Department</label>
            </div>
            <div class="form-group">
              <input type="" class="form-control" v-model="Apply.T2_YearInSchool"
                :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請填寫年級" aria-describedby=""
                placeholder="請填寫年級">
              <label for=""><span><span class="required">*</span>年級</span>Year in School</label>
            </div>
            <div class="form-group"></div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 2" v-show="Step == 1 || Step == 3">
            <h2>交換計畫<span>Exchange Program</span></h2>
            <!-- <div class="form-group full">
              <input type="" class="form-control" v-model="Apply.T2_ExchangeDepartment"
                :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請填寫系所" aria-describedby=""
                placeholder="請填寫系所">
              <label for=""><span><span class="required">*</span>系所</span>Department or Graduate Institute in which you
                intend to exchange in</label>
            </div> -->
            <div class="form-group full">
              <select class="form-control" v-model="Apply.T2_ExchangeProgram"
                :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇學制">
                <option value="" disabled selected>請選擇學制</option>
                <option value="學士">學士 Bachelor</option>
                <option value="碩士">碩士 Master</option>
                <option value="博士">博士 Ph.D</option>
              </select>
              <label for=""><span><span class="required">*</span>學制</span>The program in this department in which you
                intend to exchange in</label>
            </div>
            <div class="form-group full">
              <select class="form-control" v-model="Apply.T2_ExchangePeriod" :data-required="ApplyType == 2 ? '1' : '0'"
                data-required-msg="請選擇交換時間">
                <option value="" disabled selected>請選擇交換時間</option>
                <option value="一學期">一學期 One Semester</option>
                <option value="一學年">一學年 One (Academic) Year</option>
              </select>
              <label for=""><span><span class="required">*</span>交換時間</span>Exchange Period</label>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 2" v-show="Step == 1 || Step == 3">
            <h2>語言能力<span>Language Proficiency</span></h2>
            <div class="language">
              <div class="form-group">
                <span class="required">*</span><input type="" class="form-control" id="" aria-describedby=""
                  placeholder="中文 Chinese" disabled>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_CN_R"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>讀</span>Reading</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_CN_W"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>寫</span>Writing</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_CN_L"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>聽</span>Listening</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_CN_S"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>說</span>Speaking</label>
              </div>
            </div>
            <div class="language">
              <div class="form-group">
                <span class="required">*</span><input type="" class="form-control" id="" aria-describedby=""
                  placeholder="英文 English" disabled>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_EN_R"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>讀</span>Reading</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_EN_W"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>寫</span>Writing</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_EN_L"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>聽</span>Listening</label>
              </div>

              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_EN_S"
                  :data-required="ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>說</span>Speaking</label>
              </div>
            </div>
            <div class="language">
              <div class="form-group">
                <input type="" class="form-control" v-model="Apply.T2_LangSkill_O1_Name" placeholder="請填寫語言">
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O1_R"
                  :data-required="Apply.T2_LangSkill_O1_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>讀</span>Reading</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O1_W"
                  :data-required="Apply.T2_LangSkill_O1_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>寫</span>Writing</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O1_L"
                  :data-required="Apply.T2_LangSkill_O1_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>聽</span>Listening</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O1_S"
                  :data-required="Apply.T2_LangSkill_O1_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>說</span>Speaking</label>
              </div>
            </div>
            <div class="language">
              <div class="form-group">
                <input type="" class="form-control" v-model="Apply.T2_LangSkill_O2_Name" aria-describedby=""
                  placeholder="請填寫語言">
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O2_R"
                  :data-required="Apply.T2_LangSkill_O2_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>讀</span>Reading</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O2_W"
                  :data-required="Apply.T2_LangSkill_O2_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>寫</span>Writing</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O2_L"
                  :data-required="Apply.T2_LangSkill_O2_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>聽</span>Listening</label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T2_LangSkill_O2_S"
                  :data-required="Apply.T2_LangSkill_O2_Name && ApplyType == 2 ? '1' : '0'" data-required-msg="請選擇語言能力">
                  <option value="-1" disabled selected>請選擇</option>
                  <option value="4">優 Excellent</option>
                  <option value="3">良 Good</option>
                  <option value="2">可 Fair</option>
                  <option value="1">差 Poor</option>
                </select>
                <label for=""><span>說</span>Speaking</label>
              </div>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 3" v-show="Step == 1 || Step == 3">
            <h2>個人基本資料</h2>
            <div class="personal_box">
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.T3_Name" data-required="0"
                  data-required-msg="請填寫中文姓名" aria-describedby="" placeholder="請填寫中文姓名">
                <label for=""><span>中文姓名</span>Chinese Full Name</label>
              </div>
              <div class="form-group two">
                <input type="text" class="form-control" v-model="Apply.T3_Name_EN_First" data-required="1"
                  data-required-msg="請填寫英文姓名" aria-describedby="" placeholder="first name"
                  @input="formatEnglishNameFirst">
                <input type="text" class="form-control" v-model="Apply.T3_Name_EN_Last" data-required="1"
                  data-required-msg="請填寫英文姓名" aria-describedby="" placeholder="last name"
                  @input="formatEnglishNameLast">
                <label for=""><span><span class="required">*</span>英文姓名</span>English Full Name</label>
              </div>
              <div style="padding-left: 16px;">
                請依護照資料輸入，僅限輸入大寫英文字母（A–Z）及空白鍵。<br />
                Please enter the information exactly as shown on your passport.<br />
                Only uppercase English letters (A–Z) and spaces are allowed.
              </div>
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.T3_IdentityNumber" data-required="1"
                  data-required-msg="請填寫身分證號" aria-describedby="" placeholder="請填寫身分證號">
                <label for=""><span><span class="required">*</span>身分證號</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.T3_Gender" data-required="1" data-required-msg="請選擇性別">
                  <option value="-1" disabled selected>請選擇性別</option>
                  <option value="1">男</option>
                  <option value="2">女</option>
                  <option value="3">非二元</option>
                  <option value="4">其他</option>
                </select>
                <label for=""><span><span class="required">*</span>性別</span> Gender</label>
              </div>
              <div class="form-group">
                <date-picker class="form-control" v-model="Apply.T3_Birthday" format="YYYY/MM/DD" value-type="format"
                  :input-attr="{ placeholder: '', 'data-required': '1', 'data-required-msg': '請填寫生日(西元年月日)' }"></date-picker>
                <input type="text" class="form-control" v-model="Apply.T3_Birthday" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>生日(西元年月日)</span> Date of Birth</label>
              </div>
            </div>
            <div class="file_box">
              <div class="custom_file">
                <input ref="upload" type="file" class="" accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg" id="Photo"
                  @change="previewFiles">
                <img id="Photo_preview" :src="Apply.Photo ? Apply.Photo : '#'"
                  :style="Apply.Photo ? 'opacity: 1;' : ''" />
                <div class="upload">選擇檔案 Choose file</div>
                <p>
                  <span><span class="required">*</span>上傳證件照 2-inch ID photo</span>
                  <br>
                  僅支援圖片且小於10MB以下的檔案
                </p>
                <input type="hidden" v-model="Apply.Photo" id="photo_data" data-required="1"
                  data-required-msg="請上傳證件照" />
              </div>
            </div>
            <div class="form-group">
              <vue-tel-input ref="T3_Phone" class="form-control phone-control" v-model="Apply.T3_Phone"
                :mode="'international'" :defaultCountry="phoneDefaultCountry"
                :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                :inputOptions="{ placeholder: '請填寫手機' }" autocomplete="new-phone"></vue-tel-input>
              <input type="text" class="form-control" v-model="Apply.T3_Phone" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>電話(加國碼)</span>Phone Number</label>
            </div>
            <div class="form-group">
              <input type="email" class="form-control" v-model="Apply.T3_Email" data-required="1"
                data-required-msg="請填寫電子郵件" aria-describedby="" placeholder="請填寫電子郵件">
              <label for=""><span><span class="required">*</span>電子郵件</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_HomePhoneNumber" data-required="1"
                data-required-msg="請填寫住家電話" aria-describedby="" placeholder="請填寫住家電話">
              <label for=""><span><span class="required">*</span>住家電話</span>Home Phone Number</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_ContactAddress" data-required="1"
                data-required-msg="請填寫通訊地址" aria-describedby="" placeholder="請填寫通訊地址">
              <label for=""><span><span class="required">*</span>通訊地址</span>Contact Address</label>
            </div>
            <div class="form-group two">
              <select class="form-control" v-model="Apply.T3_College" data-required="1" data-required-msg="請選擇學院"
                @change="Apply.T3_Department = ''">
                <option value="" disabled selected>請選擇學院</option>
                <option value="美術學院">美術學院</option>
                <option value="設計學院">設計學院</option>
                <option value="傳播學院">傳播學院</option>
                <option value="表演藝術學院">表演藝術學院</option>
                <option value="人文學院">人文學院</option>
              </select>
              <select class="form-control" v-model="Apply.T3_Department" data-required="1" data-required-msg="請選擇系所">
                <option value="" disabled selected>請選擇系所</option>
                <option v-if="Apply.T3_College == '美術學院'" value="美術學系">美術學系</option>
                <option v-if="Apply.T3_College == '美術學院'" value="書畫藝術學系">書畫藝術學系</option>
                <option v-if="Apply.T3_College == '美術學院'" value="雕塑學系">雕塑學系</option>
                <option v-if="Apply.T3_College == '美術學院'" value="古蹟藝術修護學系">古蹟藝術修護學系</option>
                <option v-if="Apply.T3_College == '美術學院'" value="版畫藝術碩士班">版畫藝術碩士班</option>
                <option v-if="Apply.T3_College == '美術學院'" value="當代視覺文化博士班">當代視覺文化博士班</option>
                <!-- <option v-if="Apply.T3_College == '設計學院'" value="美術學系">美術學系</option> -->
                <option v-if="Apply.T3_College == '設計學院'" value="視覺傳達設計學系">視覺傳達設計學系</option>
                <option v-if="Apply.T3_College == '設計學院'" value="工藝設計學系">工藝設計學系</option>
                <option v-if="Apply.T3_College == '設計學院'" value="多媒體動畫藝術學系">多媒體動畫藝術學系</option>
                <option v-if="Apply.T3_College == '設計學院'" value="創意產業研究所">創意產業研究所</option>
                <!-- <option v-if="Apply.T3_College == '傳播學院'" value="美術學系">美術學系</option> -->
                <option v-if="Apply.T3_College == '傳播學院'" value="圖文傳播藝術學系">圖文傳播藝術學系</option>
                <option v-if="Apply.T3_College == '傳播學院'" value="廣播電視學系">廣播電視學系</option>
                <option v-if="Apply.T3_College == '傳播學院'" value="電影學系">電影學系</option>
                <option v-if="Apply.T3_College == '傳播學院'" value="影音創作與數位媒體產業研究所">影音創作與數位媒體產業研究所</option>
                <!-- <option v-if="Apply.T3_College == '表演藝術學院'" value="美術學系">美術學系</option> -->
                <option v-if="Apply.T3_College == '表演藝術學院'" value="戲劇學系">戲劇學系</option>
                <option v-if="Apply.T3_College == '表演藝術學院'" value="表演藝術跨領域博士班">表演藝術跨領域博士班</option>
                <option v-if="Apply.T3_College == '表演藝術學院'" value="中國音樂學系">中國音樂學系</option>
                <option v-if="Apply.T3_College == '表演藝術學院'" value="音樂學系">音樂學系</option>
                <option v-if="Apply.T3_College == '表演藝術學院'" value="舞蹈學系">舞蹈學系</option>
                <option v-if="Apply.T3_College == '表演藝術學院'" value="跨域表演藝術研究所">跨域表演藝術研究所</option>
                <!-- <option v-if="Apply.T3_College == '人文學院'" value="美術學系">美術學系</option> -->
                <option v-if="Apply.T3_College == '人文學院'" value="藝術管理與文化政策研究所">藝術管理與文化政策研究所</option>
                <option v-if="Apply.T3_College == '人文學院'" value="藝術與人文教學研究所">藝術與人文教學研究所</option>
              </select>
              <label for=""><span><span class="required">*</span>就讀系所</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_EduLevel" data-required="1" data-required-msg="請選擇學位別">
                <option value="" disabled selected>請選擇學位別</option>
                <option value="學士班">學士班</option>
                <option value="碩士班">碩士班</option>
                <option value="博士班">博士班</option>
                <option value="碩士在職專班">碩士在職專班</option>
              </select>
              <label for=""><span><span class="required">*</span>學位別</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_Grade" data-required="1" data-required-msg="請選擇學位別">
                <option value="" disabled selected>請選擇年級</option>
                <option value="大一">大一</option>
                <option value="大二">大二</option>
                <option value="大三">大三</option>
                <option value="大四">大四</option>
                <option value="大五">大五</option>
                <option value="大六">大六</option>
                <option value="大七">大七</option>
                <option value="碩一">碩一</option>
                <option value="碩二">碩二</option>
                <option value="碩三">碩三</option>
                <option value="博一">博一</option>
                <option value="博二">博二</option>
                <option value="博三">博三</option>
                <option value="博四">博四</option>
                <option value="博五">博五</option>
                <option value="博六">博六</option>
              </select>
              <label for=""><span><span class="required">*</span>年級</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_StudentNumber" data-required="1"
                data-required-msg="請填寫學號" aria-describedby="" placeholder="請填寫學號">
              <label for=""><span><span class="required">*</span>學號</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group full">
              <input type="text" class="form-control" v-model="Apply.T3_MainDepartment" data-required="1"
                data-required-msg="請填寫主修/專攻" aria-describedby="" placeholder="請填寫主修/專攻">
              <label for=""><span><span class="required">*</span>主修/專攻(中文)</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 3" v-show="Step == 1 || Step == 3">
            <h2>緊急聯絡人</h2>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_EmergencyName" data-required="1"
                data-required-msg="請填寫姓名" aria-describedby="" placeholder="請填寫姓名">
              <label for=""><span><span class="required">*</span>姓名</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_EmergencyName_EN" data-required="1"
                data-required-msg="請填寫英文姓名" aria-describedby="" placeholder="請填寫英文姓名">
              <label for=""><span><span class="required">*</span>英文姓名</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_EmergencyRelation" data-required="1"
                data-required-msg="請填寫關係" aria-describedby="" placeholder="請填寫關係">
              <label for=""><span><span class="required">*</span>關係</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="email" class="form-control" v-model="Apply.T3_EmergencyEmail" data-required="1"
                data-required-msg="請填寫電子郵件" aria-describedby="" placeholder="請填寫電子郵件">
              <label for=""><span>電子郵件</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_EmergencyHomePhone" data-required="1"
                data-required-msg="請填寫住家電話" aria-describedby="" placeholder="請填寫住家電話">
              <label for=""><span><span class="required">*</span>住家電話</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" v-model="Apply.T3_EmergencyPhone" data-required="1"
                data-required-msg="請填寫手機" aria-describedby="" placeholder="請填寫手機">
              <label for=""><span><span class="required">*</span>手機</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 3" v-show="Step == 1 || Step == 3">
            <h2>申請資料</h2>
            <div class="form-group full">
              <!-- <input type="text" class="form-control" v-model="Apply.T3_ApplySchool" data-required="1"
                data-required-msg="請填寫申請學校(志願1)" aria-describedby="" placeholder="請填寫申請學校"> -->
              <Select2 class="form-control select2-control" v-model="Apply.T3_ApplySchool"
                :options="ApplyData.ContractSchools" :settings="{ placeholder: '請選擇申請學校' }" />
              <input type="text" class="form-control"
                :value="selectedText(Apply.T3_ApplySchool, ApplyData.ContractSchools)" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>申請學校(志願1)</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="" class="form-control" v-model="Apply.T3_ApplyDepartment" data-required="1"
                data-required-msg="請填寫申請系所" aria-describedby="" placeholder="請填寫申請系所">
              <label for=""><span><span class="required">*</span>申請系所_中文(志願1)</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <input type="" class="form-control" v-model="Apply.T3_ApplyDepartment_EN" data-required="1"
                data-required-msg="請填寫申請系所" aria-describedby="" placeholder="請填寫申請系所">
              <label for=""><span><span class="required">*</span>申請系所_英文(志願1)</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group month_box">
              <date-picker type="month" class="form-control" v-model="Apply.T3_StudyDurationStart" format="YYYY/MM"
                value-type="format"
                :input-attr="{ placeholder: '', 'data-required': '1', 'data-required-msg': '請填寫修讀期間(起)' }"></date-picker>
              <input type="text" class="form-control" v-model="Apply.T3_StudyDurationStart" v-show="Step == 3" disabled>
              <date-picker type="month" class="form-control" v-model="Apply.T3_StudyDurationEnd" format="YYYY/MM"
                value-type="format"
                :input-attr="{ placeholder: '', 'data-required': '1', 'data-required-msg': '請填寫修讀期間(迄)' }"></date-picker>
              <input type="text" class="form-control" v-model="Apply.T3_StudyDurationEnd" v-show="Step == 3" disabled>
              <label for=""><span><span class="required">*</span>就學期間</span>Study Duration</label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_ApplyProgram" data-required="1" data-required-msg="請選擇學制">
                <option value="" disabled selected>請選擇學制</option>
                <option value="學士班">學士班</option>
                <option value="碩士班">碩士班</option>
                <option value="博士班">博士班</option>
                <option value="碩士在職專班">碩士在職專班</option>
                <option value="進修學士班">進修學士班</option>
                <option value="二年制在職專班">二年制在職專班</option>
              </select>
              <label for=""><span><span class="required">*</span>申請學制</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_ApplyGrade" data-required="1" data-required-msg="請選擇申請年級">
                <option value="" disabled selected>請選擇申請年級</option>
                <option value="大一">大一</option>
                <option value="大二">大二</option>
                <option value="大三">大三</option>
                <option value="大四">大四</option>
                <option value="大五">大五</option>
                <option value="大六">大六</option>
                <option value="大七">大七</option>
                <option value="碩一">碩一</option>
                <option value="碩二">碩二</option>
                <option value="碩三">碩三</option>
                <option value="博一">博一</option>
                <option value="博二">博二</option>
                <option value="博三">博三</option>
                <option value="博四">博四</option>
                <option value="博五">博五</option>
                <option value="博六">博六</option>
              </select>
              <label for=""><span><span class="required">*</span>申請年級</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_BeSoldier" data-required="1" data-required-msg="請選擇是否需服兵役">
                <option value="" disabled selected>請選擇</option>
                <option value="是">是</option>
                <option value="否">否</option>
              </select>
              <label for=""><span><span class="required">*</span>是否需服兵役</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_Award" data-required="1" data-required-msg="請選擇競賽得獎證明">
                <option value="" disabled selected>請選擇</option>
                <option value="是">是</option>
                <option value="否">否</option>
              </select>
              <label for=""><span><span class="required">*</span>競賽得獎證明</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="form-group">
              <select class="form-control" v-model="Apply.T3_Identity">
                <option value="" selected>無</option>
                <option value="港生">港生</option>
                <option value="澳生">澳生</option>
                <option value="僑生">僑生</option>
                <option value="外籍生">外籍生</option>
              </select>
              <label for=""><span><span class="required">*</span>具有以下身份</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
            </div>
            <div class="score_box">
              <div class="title">
                <h3 class="">語檢成績(有效期限內)</h3>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="cbox_T3_TestScore_NoNeed"
                    v-model="Apply.T3_TestScore_NoNeed">
                  <label class="form-check-label" for="cbox_T3_TestScore_NoNeed">不需檢附語檢成績</label>
                </div>
              </div>
              <hr>
              <div class="form-group" v-show="!Apply.T3_TestScore_NoNeed">
                <input type="" class="form-control" v-model="Apply.T3_TestName"
                  :data-required="!Apply.T3_TestScore_NoNeed ? '1' : '0'" data-required-msg="請填寫測驗名稱"
                  aria-describedby="" placeholder="請填寫測驗名稱">
                <label for=""><span><span class="required">*</span>測驗名稱</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group" v-show="!Apply.T3_TestScore_NoNeed">
                <input type="" class="form-control" v-model="Apply.T3_TestScore"
                  :data-required="!Apply.T3_TestScore_NoNeed ? '1' : '0'" data-required-msg="請填寫分數" aria-describedby=""
                  placeholder="請填寫分數">
                <label for=""><span><span class="required">*</span>分數</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group" v-show="!Apply.T3_TestScore_NoNeed">
                <input type="" class="form-control" v-model="Apply.T3_TestLevel"
                  :data-required="!Apply.T3_TestScore_NoNeed ? '1' : '0'" data-required-msg="請填寫等級" aria-describedby=""
                  placeholder="請填寫等級">
                <label for=""><span><span class="required">*</span>等級</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group" v-show="!Apply.T3_TestScore_NoNeed">
                <date-picker class="form-control" v-model="Apply.T3_TestDay" format="YYYY/MM/DD" value-type="format"
                  :input-attr="{ placeholder: '', 'data-required': !Apply.T3_TestScore_NoNeed ? '1' : '0', 'data-required-msg': '請填寫考試日期' }"></date-picker>
                <input type="text" class="form-control" v-model="Apply.T3_TestDay" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>考試日期</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
            </div>
            <div class="score_box">
              <div class="title">
                <h3 class="">學業成績</h3>
              </div>
              <hr>
              <div class="form-group">
                <input type="" class="form-control" v-model="Apply.T3_AverageScore" data-required="1"
                  data-required-msg="請填寫歷年學業平均成績（各學期加總平均）" aria-describedby="" placeholder="請填寫歷年學業平均成績（各學期加總平均）">
                <label for=""><span><span class="required">*</span>歷年學業平均成績（各學期加總平均）</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <input type="" class="form-control checkbox_1" v-show="!Apply.T3_Ranking_NoNeed"
                  v-model="Apply.T3_Ranking" :data-required="!Apply.T3_Ranking_NoNeed ? '1' : '0'"
                  data-required-msg="請填寫歷年班排名/人數" aria-describedby="" placeholder="請填寫歷年班排名/人數">
                <label for=""><span><span class="required">*</span>歷年班排名/人數</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="cbox_T3_Ranking_NoNeed"
                    v-model="Apply.T3_Ranking_NoNeed">
                  <label class="form-check-label" for="cbox_T3_Ranking_NoNeed">我是研究生免填</label>
                </div>
              </div>
              <div class="form-group">
                <input type="" class="form-control checkbox_2" v-show="!Apply.T3_GPA_NoNeed" v-model="Apply.T3_GPA"
                  :data-required="!Apply.T3_GPA_NoNeed ? '1' : '0'" data-required-msg="請填寫歷年學業GPA成績" aria-describedby=""
                  placeholder="請填寫歷年學業GPA成績">
                <label for=""><span><span class="required">*</span>歷年學業GPA成績</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="cbox_T3_GPA_NoNeed" v-model="Apply.T3_GPA_NoNeed">
                  <label class="form-check-label" for="cbox_T3_GPA_NoNeed">我不用提供歷年英文成績單</label>
                </div>
              </div>
            </div>
          </div>
          <div class="btn_box" v-if="Apply" v-show="Step == 1 && (ApplyType != 2 || Apply.Nationality != 'A00')">
            <button @click="gotoStep(2)">下一步</button>
          </div>
          <div class="btn_box" v-if="Apply" v-show="Step == 1 && ApplyType == 2 && Apply.Nationality == 'A00'">
            <button @click="gotoStep(5)">下一步</button>
          </div>

          <!-- 大陸地區資料 -->
          <div class="form_china" v-if="Apply && ApplyType == 2"
            v-show="Apply.Nationality == 'A00' && (Step == 5 || Step == 3)">

            <div class="box review">
              <h2>中華民國臺灣地區入出境申請書(大陸地區人民適用)</h2>
              <ul class="rule">
                <li>依臺灣地區與大陸地區人民關係條例第七十七條規定：「大陸地區人民在臺灣地區以外之地區，犯內亂罪、外患罪，經許可進入臺灣地區，而於申請時據實申報者，免予追訴、處罰。」</li>
                <li>本申請書由申請人或代申請人親自據實填寫，如未據實填寫經查獲者，得撤銷其入境許可，並限期離境。</li>
                <li>申請人來台期間應遵守中華民國法令，並依限離臺，且不得從事與許可目的不符之活動。</li>
                <li>此申請表僅接受繁體字填寫</li>
              </ul>
            </div>
            <div class="box review">
              <h2>申請人資料<span>Personal Information of Applicant</span></h2>
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.Name" data-required="1"
                  data-required-msg="請填寫中文姓名" aria-describedby="" placeholder="請填寫中文姓名" disabled>
                <label for=""><span>中文姓名</span>Chinese Full Name</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" v-model="Apply.Name_EN" data-required="1"
                  data-required-msg="請填寫英文姓名" aria-describedby="" placeholder="請填寫英文姓名" disabled>
                <label for=""><span><span class="required">*</span>英文姓名</span>English Full Name</label>
                <p class="note">英文姓名須與護照相同。</p>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.Gender" data-required="1" data-required-msg="請選擇性別"
                  disabled>
                  <option value="-1" disabled selected>請選擇性別</option>
                  <option value="1">男</option>
                  <option value="2">女</option>
                  <option value="3">非二元</option>
                  <option value="4">其他</option>
                </select>
                <label for=""><span><span class="required">*</span>性別</span> Gender</label>
              </div>
              <div class="form-group">
                <date-picker class="form-control" v-model="Apply.Birthday" format="YYYY/MM/DD" value-type="format"
                  :input-attr="{ placeholder: '', 'data-required': '1', 'data-required-msg': '請填寫生日(西元年月日)' }"
                  disabled></date-picker>
                <input type="text" class="form-control" v-model="Apply.Birthday" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>生日(西元年月日)</span> Date of Birth</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫身分證字號"
                  data-required-msg="請填寫身分證字號" v-model="Apply.TC_IDNumber" data-required="1"
                  @input="formatChinaIDNumber" maxlength="18">
                <label for=""><span><span class="required">*</span>身分證字號</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <Select2 class="form-control select2-control" v-model="Apply.TC_BirthPlace"
                  :options="ApplyData.BirthPlaces" :settings="{ placeholder: '請選擇出生地' }" />
                <input type="text" class="form-control" :value="Apply.TC_BirthPlace" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>出生地</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <hr class="line">
              <div class="form-group full">
                <label for=""><span><span class="required">*</span>是否具其他國籍護照</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="TC_HasOtherNationalityPassport_Y"
                      id="TC_HasOtherNationalityPassport_Y" :value="true"
                      v-model="Apply.TC_HasOtherNationalityPassport">
                    <label class="form-check-label" for="TC_HasOtherNationalityPassport_Y">是</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="TC_HasOtherNationalityPassport_N"
                      id="TC_HasOtherNationalityPassport_N" :value="false"
                      v-model="Apply.TC_HasOtherNationalityPassport">
                    <label class="form-check-label" for="TC_HasOtherNationalityPassport_N">否</label>
                  </div>
                </div>
              </div>
              <template v-if="Apply.TC_HasOtherNationalityPassport">
                <div class="form-group">
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫國籍"
                    data-required-msg="請填寫國籍" v-model="Apply.TC_OtherNationality"
                    :data-required="Apply.TC_HasOtherNationalityPassport ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>所具其他國籍為</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫他國護(證)照號碼"
                    data-required-msg="請填寫他國護(證)照號碼" v-model="Apply.TC_OtherPassportNumber"
                    :data-required="Apply.TC_HasOtherNationalityPassport ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>他國護(證)照號碼</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <date-picker class="form-control" v-model="Apply.TC_OtherPassportExpiryDate" format="YYYY/MM/DD"
                    value-type="format"
                    :input-attr="{ placeholder: '', 'data-required': Apply.TC_HasOtherNationalityPassport ? '1' : '0', 'data-required-msg': '請填他國護(證)照有效期限' }"></date-picker>
                  <input type="text" class="form-control" v-model="Apply.TC_OtherPassportExpiryDate" v-show="Step == 3"
                    disabled>
                  <label for=""><span><span class="required">*</span>他國護(證)照有效期限</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group"></div>
              </template>
              <hr class="line">
              <div class="form-group">
                <select class="form-control" v-model="Apply.TC_EducationSystem" data-required="1"
                  data-required-msg="請選擇就讀學制" disabled>
                  <option value="" disabled selected>請選擇就讀學制</option>
                  <option value="大學部">大學部</option>
                  <option value="碩士班">碩士班</option>
                  <option value="博士班">博士班</option>
                </select>
                <label for=""><span><span class="required">*</span>就讀學制</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.TC_Education" data-required="1" data-required-msg="請選擇學歷"
                  :disabled="Apply.TC_EducationSystem === '大學部'">
                  <option value="" disabled selected>請選擇學歷</option>
                  <option value="高中">高中</option>
                  <option value="大學">大學</option>
                  <option value="博士">博士</option>
                </select>
                <label for=""><span><span class="required">*</span>學歷</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <select class="form-control" v-model="Apply.TC_EnrollmentDate" data-required="1"
                  data-required-msg="請選擇入學年份" @change="updateEnrollmentDate">
                  <option value="" disabled selected>請選擇入學年份</option>
                  <option v-for="year in enrollmentYears" :key="year" :value="year + '/09/01'">{{ year + '/09/01' }}
                  </option>
                </select>
                <label for=""><span><span class="required">*</span>入學日</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫所屬學校"
                  data-required-msg="請填寫所屬學校" v-model="Apply.TC_SchoolName" data-required="1" disabled>
                <label for=""><span><span class="required">*</span>所屬學校</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫職業"
                  data-required-msg="請填寫職業" v-model="Apply.TC_Occupation" data-required="1" disabled>
                <label for=""><span><span class="required">*</span>職業</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group"></div>
              <div class="form-group full">
                <!-- <div class="address_group">
                  <input type="text" class="form-control" aria-describedby="" placeholder="門牌號碼"
                    data-required-msg="請填寫門牌號碼" v-model="Apply.TC_AddressNumber" data-required="1">
                </div> -->
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫居住地址"
                  data-required-msg="請填寫居住地址" v-model="Apply.TC_ResidentialAddress" data-required="1">
                <label for=""><span><span class="required">*</span>居住地址(請填寫完整地址包含門牌號碼)</span>Address</label>
              </div>
              <div class="form-group">
                <vue-tel-input ref="TC_ResidentialMobile" class="form-control phone-control"
                  v-model="Apply.TC_ResidentialMobile" :mode="'international'" :defaultCountry="phoneDefaultCountry"
                  :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                  :inputOptions="{ placeholder: '請填寫手機號碼' }" autocomplete="new-phone"></vue-tel-input>
                <input type="text" class="form-control" v-model="Apply.TC_ResidentialMobile" v-show="Step == 3"
                  disabled>
                <label for=""><span><span class="required">*</span>居住地手機號碼</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <Select2 class="form-control select2-control" v-model="Apply.TC_CurrentDistrict"
                  :options="ApplyData.Countrys" :settings="{ placeholder: '請選擇現住地區' }" />
                <input type="text" class="form-control"
                  :value="selectedText(Apply.TC_CurrentDistrict, ApplyData.Countrys)" v-show="Step == 3" disabled>
                <label for=""><span><span class="required">*</span>現住地區</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group">
                <input type="email" class="form-control" v-model="Apply.Email" data-required="1"
                  data-required-msg="請填寫電子郵件" aria-describedby="" placeholder="請填寫電子郵件" disabled>
                <label for=""><span><span class="required">*</span>電子郵件</span>Email</label>
                <p class="note">不可使用大陸地區之email，如.cn、.qq。</p>
              </div>
              <div class="form-group"></div>
            </div>
            <div class="box review">
              <h2>父母親資料<span></span></h2>
              <div class="form-group full" style="margin-bottom: 0px;">
                <div class="check_group" style="margin-top: -10px;">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="TC_FatherDead" id="TC_FatherDead"
                      v-model="Apply.TC_FatherDead">
                    <label class="form-check-label" for="TC_FatherDead">父歿</label>
                  </div>
                </div>
              </div>
              <template v-if="!Apply.TC_FatherDead">
                <div class="form-group">
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫父親姓名"
                    data-required-msg="請填寫父親姓名" v-model="Apply.TC_FatherName"
                    :data-required="!Apply.TC_FatherDead ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>父親姓名</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <date-picker class="form-control" v-model="Apply.TC_FatherBirthday" format="YYYY/MM/DD"
                    value-type="format"
                    :input-attr="{ placeholder: '', 'data-required': !Apply.TC_FatherDead ? '1' : '0', 'data-required-msg': '請填寫生日(西元年月日)' }"></date-picker>
                  <input type="text" class="form-control" v-model="Apply.TC_FatherBirthday" v-show="Step == 3" disabled>
                  <label for=""><span><span class="required">*</span>生日(西元年月日)</span> Date of Birth</label>
                </div>
                <div class="form-group">
                  <select class="form-control" v-model="Apply.TC_FatherOccupation"
                    :data-required="!Apply.TC_FatherDead ? '1' : '0'" data-required-msg="請選擇父親職業">
                    <option value="" disabled selected>請選擇父親職業</option>
                    <option value="軍">軍</option>
                    <option value="公">公</option>
                    <option value="教">教</option>
                    <option value="私校">私校</option>
                    <option value="商">商</option>
                    <option value="農">農</option>
                    <option value="工">工</option>
                    <option value="醫">醫</option>
                    <option value="宗">宗</option>
                    <option value="演">演</option>
                    <option value="新聞">新聞</option>
                    <option value="漁">漁</option>
                    <option value="輪">輪</option>
                    <option value="學">學</option>
                    <option value="自">自</option>
                    <option value="其他">其他</option>
                    <option value="無">無</option>
                    <option value="警">警</option>
                  </select>
                  <label for=""><span><span class="required">*</span>職業</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <vue-tel-input ref="TC_FatherPhone" class="form-control phone-control" v-model="Apply.TC_FatherPhone"
                    :mode="'international'" :defaultCountry="phoneDefaultCountry"
                    :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                    :inputOptions="{ placeholder: '請填寫電話' }" autocomplete="new-phone"></vue-tel-input>
                  <input type="text" class="form-control" v-model="Apply.TC_FatherPhone" v-show="Step == 3" disabled>
                  <label for=""><span><span class="required">*</span>電話</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group full">
                  <!-- <div class="address_group">
                    <input type="text" class="form-control" aria-describedby="" placeholder="門牌號碼"
                      data-required-msg="請填寫門牌號碼" v-model="Apply.TC_FatherAddressNumber"
                      :data-required="!Apply.TC_FatherDead ? '1' : '0'">
                    <input type="text" class="form-control" aria-describedby="" placeholder="請填寫居住地址"
                      data-required-msg="請填寫居住地址" v-model="Apply.TC_FatherAddress"
                      :data-required="!Apply.TC_FatherDead ? '1' : '0'">
                  </div> -->
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫居住地址"
                    data-required-msg="請填寫居住地址" v-model="Apply.TC_FatherAddress"
                    :data-required="!Apply.TC_FatherDead ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>現住地址(請填寫完整地址包含門牌號碼)</span>Address</label>
                </div>
              </template>
              <hr class="line">
              <div class="form-group full" style="margin-bottom: 0px;">
                <div class="check_group" style="margin-top: -10px;">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="TC_MotherDead" id="TC_MotherDead"
                      v-model="Apply.TC_MotherDead">
                    <label class="form-check-label" for="TC_MotherDead">母歿</label>
                  </div>
                </div>
              </div>
              <template v-if="!Apply.TC_MotherDead">
                <div class="form-group">
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫母親姓名"
                    data-required-msg="請填寫母親姓名" v-model="Apply.TC_MotherName"
                    :data-required="!Apply.TC_MotherDead ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>母親姓名</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <date-picker class="form-control" v-model="Apply.TC_MotherBirthday" format="YYYY/MM/DD"
                    value-type="format"
                    :input-attr="{ placeholder: '', 'data-required': !Apply.TC_MotherDead ? '1' : '0', 'data-required-msg': '請填寫生日(西元年月日)' }"></date-picker>
                  <input type="text" class="form-control" v-model="Apply.TC_MotherBirthday" v-show="Step == 3" disabled>
                  <label for=""><span><span class="required">*</span>生日(西元年月日)</span> Date of Birth</label>
                </div>
                <div class="form-group">
                  <select class="form-control" v-model="Apply.TC_MotherOccupation"
                    :data-required="!Apply.TC_MotherDead ? '1' : '0'" data-required-msg="請選擇母親職業">
                    <option value="" disabled selected>請選擇母親職業</option>
                    <option value="軍">軍</option>
                    <option value="公">公</option>
                    <option value="教">教</option>
                    <option value="私校">私校</option>
                    <option value="商">商</option>
                    <option value="農">農</option>
                    <option value="工">工</option>
                    <option value="醫">醫</option>
                    <option value="宗">宗</option>
                    <option value="演">演</option>
                    <option value="新聞">新聞</option>
                    <option value="漁">漁</option>
                    <option value="輪">輪</option>
                    <option value="學">學</option>
                    <option value="自">自</option>
                    <option value="其他">其他</option>
                    <option value="無">無</option>
                    <option value="警">警</option>
                  </select>
                  <label for=""><span><span class="required">*</span>職業</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group">
                  <vue-tel-input ref="TC_MotherPhone" class="form-control phone-control" v-model="Apply.TC_MotherPhone"
                    :mode="'international'" :defaultCountry="phoneDefaultCountry"
                    :dropdownOptions="{ showFlags: true, showDialCodeInSelection: true }"
                    :inputOptions="{ placeholder: '請填寫電話' }" autocomplete="new-phone"></vue-tel-input>
                  <input type="text" class="form-control" v-model="Apply.TC_MotherPhone" v-show="Step == 3" disabled>
                  <label for=""><span><span class="required">*</span>電話</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                        Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                      style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                        Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
                </div>
                <div class="form-group full">
                  <!-- <div class="address_group">
                    <input type="text" class="form-control" aria-describedby="" placeholder="門牌號碼"
                      data-required-msg="請填寫門牌號碼" v-model="Apply.TC_MotherAddressNumber"
                      :data-required="!Apply.TC_MotherDead ? '1' : '0'">
                    <input type="text" class="form-control" aria-describedby="" placeholder="請填寫居住地址"
                      data-required-msg="請填寫居住地址" v-model="Apply.TC_MotherAddress"
                      :data-required="!Apply.TC_MotherDead ? '1' : '0'">
                  </div> -->
                  <input type="text" class="form-control" aria-describedby="" placeholder="請填寫居住地址"
                    data-required-msg="請填寫居住地址" v-model="Apply.TC_MotherAddress"
                    :data-required="!Apply.TC_MotherDead ? '1' : '0'">
                  <label for=""><span><span class="required">*</span>現住地址(請填寫完整地址包含門牌號碼)</span>Address</label>
                </div>
              </template>
            </div>
            <div class="box review">
              <p class="">申請人現任或曾任大陸地區黨務、行政、軍事或具政治性機關（構）、團體之職務或為其成員者，請於本欄據實詳述。如未據實填寫，經查獲或遭人檢舉者，應負法律責任。</p>
              <div class="form-group full">
                <label for=""><span><span
                      class="required">*</span>申請人未曾任大陸地區黨務、行政、軍事或具政治性機關（構）、團體之職務或為其成員者。</span></label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_Y"
                      id="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_Y" :value="true"
                      v-model="Apply.TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label" for="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_Y">是</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_N"
                      id="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_N" :value="false"
                      v-model="Apply.TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label" for="TC_DeclareNoChinaPartyAdminMilitaryPoliticalRole_N">否</label>
                  </div>
                </div>
              </div>
              <div class="form-group full">
                <label for=""><span><span
                      class="required">*</span>申請人曾任大陸地區黨務、行政、軍事或具政治性機關（構）、團體之職務或為其成員者？</span></label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_Y"
                      id="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_Y" :value="true"
                      v-model="Apply.TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label" for="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_Y">是</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_N"
                      id="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_N" :value="false"
                      v-model="Apply.TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label" for="TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_N">否</label>
                  </div>
                </div>
              </div>
              <div class="form-group full" v-if="Apply.TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫任職經歷"
                  data-required-msg="請填寫任職經歷" v-model="Apply.TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole_Content"
                  :data-required="Apply.TC_DeclarePastChinaPartyAdminMilitaryPoliticalRole ? '1' : '0'">
                <label for=""><span><span class="required">*</span>任職經歷</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group full">
                <label for=""><span><span
                      class="required">*</span>申請人現任大陸地區黨務、行政、軍事或具政治性機關（構）、團體之職務或為其成員者？</span></label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_Y"
                      id="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_Y" :value="true"
                      v-model="Apply.TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label"
                      for="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_Y">是</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio"
                      name="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_N"
                      id="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_N" :value="false"
                      v-model="Apply.TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole">
                    <label class="form-check-label"
                      for="TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_N">否</label>
                  </div>
                </div>
              </div>
              <div class="form-group full" v-if="Apply.TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫任職經歷"
                  data-required-msg="請填寫任職經歷"
                  v-model="Apply.TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole_Content"
                  :data-required="Apply.TC_DeclareCurrentChinaPartyAdminMilitaryPoliticalRole ? '1' : '0'">
                <label for=""><span><span class="required">*</span>任職經歷</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                    }}</span><span style="color: red; margin-left: 8px;"
                    v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              </div>
              <div class="form-group full">
                <label for=""><span><span class="required">*</span>以上所填內容，俱屬事實，如有捏造或虛假情事，願負法律責任。</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                      Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span
                    style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                      Apply.TA_OtherExcellenceProofDocs_2_StatusContent
                    }}</span></label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="TC_DeclareTruthResponsibility"
                      id="TC_DeclareTruthResponsibility" v-model="Apply.TC_DeclareTruthResponsibility">
                    <label class="form-check-label" for="TC_DeclareTruthResponsibility">是</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn_box" v-if="Apply" v-show="Step == 5 && ApplyType == 2 && Apply.Nationality == 'A00'">
            <button @click="gotoStep(1)">上一步</button>
            <button @click="gotoStep(2)">下一步</button>
          </div>

          <!-- 檔案上傳區(Step3確認時也用同一畫面) -->
          <div class="box review-file" v-if="Apply && ApplyType == 1" v-show="Step == 2 || Step == 3">
            <h2>上傳申請文件 Required Documents Upload<span></span> {{ Apply.T1_Passport_Status }}</h2>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_Passport_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_Passport"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_Passport_name" data-namgtag="1" v-model="T1_Passport_name" />
                <input type="hidden" v-model="Apply.T1_Passport" id="T1_Passport_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳護照" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>護照</span>Copy of Passport<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T1_Passport_Status === 2">{{
                    Apply.T1_Passport_StatusContent
                  }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T1_Passport && !Apply.T1_Passport.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_Passport_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_Passport.includes('data:image')" :src="Apply.T1_Passport">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_Passport" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_Passport && Apply.T1_Passport.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_HighCert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_HighCert"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_HighCert_name" data-namgtag="1" v-model="T1_HighCert_name" />
                <input type="hidden" v-model="Apply.T1_HighCert" id="T1_HighCert_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'"
                  data-required-msg="請上傳最高學歷或同等學力證明文件、學歷認證相關證明文件(需經外館驗證)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>最高學歷或同等學力證明文件、學歷認證相關證明文件(需經外館驗證)</span>Graduation
                Certificate in Chinese or English (*Must be verified by the Taipei Representative Office abroad)<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T1_HighCert_Status === 2">{{
                    Apply.T1_HighCert_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T1_HighCert && !Apply.T1_HighCert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_HighCert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_HighCert.includes('data:image')" :src="Apply.T1_HighCert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_HighCert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_HighCert && Apply.T1_HighCert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_Transcript_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_Transcript"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_Transcript_name" data-namgtag="1" v-model="T1_Transcript_name" />
                <input type="hidden" v-model="Apply.T1_Transcript" id="T1_Transcript_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳歷年成績單(需經外館驗證)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>歷年成績單(需經外館驗證)</span>Full Academic Record/Transcript in
                Chinese or English (*Must be verified by the Taipei Representative Office abroad)<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T1_Transcript_Status === 2">{{
                    Apply.T1_Transcript_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_Transcript && !Apply.T1_Transcript.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_Transcript_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_Transcript.includes('data:image')" :src="Apply.T1_Transcript">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_Transcript" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_Transcript && Apply.T1_Transcript.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_BirthCertificate_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_BirthCertificate"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_BirthCertificate_name" data-namgtag="1"
                  v-model="T1_BirthCertificate_name" />
                <input type="hidden" v-model="Apply.T1_BirthCertificate" id="T1_BirthCertificate_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳出生證明(無法繳交者請使用範本)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>出生證明(無法繳交者請使用範本)</span>Birth Certificate (Use
                attachment
                if not available)<span style="color: red; margin-left: 8px;"
                  v-if="Apply.T1_BirthCertificate_Status === 2">{{
                    Apply.T1_BirthCertificate_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_BirthCertificate && !Apply.T1_BirthCertificate.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_BirthCertificate_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_BirthCertificate.includes('data:image')"
                  :src="Apply.T1_BirthCertificate">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_BirthCertificate" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_BirthCertificate && Apply.T1_BirthCertificate.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/no_birth_cert.pdf" target="_blank">範本下載 Download
                  Template</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_ProofOfFinancial_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_ProofOfFinancial"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_ProofOfFinancial_name" data-namgtag="1"
                  v-model="T1_ProofOfFinancial_name" />
                <input type="hidden" v-model="Apply.T1_ProofOfFinancial" id="T1_ProofOfFinancial_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳財力證明" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>財力證明</span>Financial Statement Issued by Bank (*in
                Chinese or English)<span style="color: red; margin-left: 8px;"
                  v-if="Apply.T1_ProofOfFinancial_Status === 2">{{
                    Apply.T1_ProofOfFinancial_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_ProofOfFinancial && !Apply.T1_ProofOfFinancial.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_ProofOfFinancial_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_ProofOfFinancial.includes('data:image')"
                  :src="Apply.T1_ProofOfFinancial">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_ProofOfFinancial" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_ProofOfFinancial && Apply.T1_ProofOfFinancial.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_SelfIntroduction_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_SelfIntroduction"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_SelfIntroduction_name" data-namgtag="1"
                  v-model="T1_SelfIntroduction_name" />
                <input type="hidden" v-model="Apply.T1_SelfIntroduction" id="T1_SelfIntroduction_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳自傳" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>中文自傳</span>Self-Introduction in Chinese<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T1_SelfIntroduction_Status === 2">{{
                    Apply.T1_SelfIntroduction_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent
                  }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_SelfIntroduction && !Apply.T1_SelfIntroduction.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_SelfIntroduction_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_SelfIntroduction.includes('data:image')"
                  :src="Apply.T1_SelfIntroduction">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_SelfIntroduction" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_SelfIntroduction && Apply.T1_SelfIntroduction.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_StudyPlan_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_StudyPlan"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_StudyPlan_name" data-namgtag="1" v-model="T1_StudyPlan_name" />
                <input type="hidden" v-model="Apply.T1_StudyPlan" id="T1_StudyPlan_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳學習計畫書" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>中文學習計畫書</span>Study Plan in Chinese<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T1_StudyPlan_Status === 2">{{
                    Apply.T1_StudyPlan_StatusContent
                  }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T1_StudyPlan && !Apply.T1_StudyPlan.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_StudyPlan_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_StudyPlan.includes('data:image')" :src="Apply.T1_StudyPlan">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_StudyPlan" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_StudyPlan && Apply.T1_StudyPlan.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_TOCFL_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_TOCFL" accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T1_TOCFL_name" data-namgtag="1" v-model="T1_TOCFL_name" />
                <input type="hidden" v-model="Apply.T1_TOCFL" id="T1_TOCFL_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳中文能力證明(TOCFL)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>中文能力證明(TOCFL)</span>Chinese Proficiency Certificate
                (TOCFL)<span style="color: red; margin-left: 8px;" v-if="Apply.T1_TOCFL_Status === 2">{{
                  Apply.T1_TOCFL_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_TOCFL && !Apply.T1_TOCFL.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_TOCFL_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_TOCFL.includes('data:image')" :src="Apply.T1_TOCFL">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_TOCFL" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_TOCFL && Apply.T1_TOCFL.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_Declaration_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_Declaration"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_Declaration_name" data-namgtag="1" v-model="T1_Declaration_name" />
                <input type="hidden" v-model="Apply.T1_Declaration" id="T1_Declaration_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳申請具結書(請見說明)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>申請具結書(請見說明)</span>Declaration (Please see the
                instruction)<span style="color: red; margin-left: 8px;" v-if="Apply.T1_Declaration_Status === 2">{{
                  Apply.T1_Declaration_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_Declaration && !Apply.T1_Declaration.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_Declaration_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_Declaration.includes('data:image')" :src="Apply.T1_Declaration">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_Declaration" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_Declaration && Apply.T1_Declaration.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/declaration.pdf" target="_blank">範本下載 Download
                  Template</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_PersonalDataAgree_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_PersonalDataAgree"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_PersonalDataAgree_name" data-namgtag="1"
                  v-model="T1_PersonalDataAgree_name" />
                <input type="hidden" v-model="Apply.T1_PersonalDataAgree" id="T1_PersonalDataAgree_data"
                  :data-required="Step == 2 && ApplyType == 1 ? '1' : '0'" data-required-msg="請上傳個人資料提供同意書(請見說明)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>個人資料提供同意書(請見說明)</span>Letter of agreement of providing
                personal information.(Please see the instruction)<span style="color: red; margin-left: 8px;"
                  v-if="Apply.T1_PersonalDataAgree_Status === 2">{{ Apply.T1_PersonalDataAgree_StatusContent
                  }}</span></label>
              <template
                v-if="Step == 3 && Apply.T1_PersonalDataAgree && !Apply.T1_PersonalDataAgree.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_PersonalDataAgree_name }}</span>
                </span>
                <template v-if="Apply.T1_PersonalDataAgree.includes('data:image')">
                  <img class="img_preview" :src="Apply.T1_PersonalDataAgree">
                </template>
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_PersonalDataAgree" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_PersonalDataAgree && Apply.T1_PersonalDataAgree.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/letter_of_agreement_of_providing.pdf"
                  target="_blank">範本下載
                  Download
                  Template</a>
              </div>
            </div>
            <!-- <div class="form-group full other_box">
              <div class="custom_file req_file">
                <input type="file" id="T1_Other" accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T1_Other_name" data-namgtag="1" v-model="T1_Other_name" />
                <input type="hidden" v-model="Apply.T1_Other" id="T1_Other_data" />
                <div class="upload">上傳</div>
              </div>
              <input type="text" class="form-control" v-model="Apply.T1_OtherURL" aria-describedby=""
                placeholder="請填寫網址">
              <label for=""><span>其它補充文件(如作品集)</span>Other requirement documents (Ex. Portfolio)</label>
              <template v-if="Step == 3 && Apply.T1_Other && !Apply.T1_Other.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_Other_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_Other.includes('data:image')" :src="Apply.T1_Other">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_Other" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_Other && Apply.T1_Other.includes('/Upload')">下載
                  Download</a>
              </div>
            </div> -->
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores"
                  id="TA_DeptRequiredDocsOrScores_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>系(所)指定文件或考試成績</span>A portfolio of art works that demonstrate the applicant’s artistic
                interest
                and talent (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores && !Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores && Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_2_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_2_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores_2"
                  id="TA_DeptRequiredDocsOrScores_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores_2 && !Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores_2.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores_2 && Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs"
                  id="TA_OtherExcellenceProofDocs_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>其他證明優秀表現之文件</span>Any other relevant experiences and certificates showing the
                applicant’s
                Qualification (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs && !Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs && Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_2_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_2_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs_2"
                  id="TA_OtherExcellenceProofDocs_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs_2 && !Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs_2.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs_2 && Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div style="width: 100%; padding: 12px 16px;">
              申請系統開放上傳下列資料：The application system accepts the following documents:<br />
              1. <span style="font-weight: 600;">中文檢定成績（PDF）</span>Chinese proficiency test score report (PDF)<br />
              2. <span style="font-weight: 600;">作品集（PDF）</span>Portfolio (PDF)<br />
              3. <span style="font-weight: 600;">研究報告（PDF）</span>Research report (PDF)<br />
              4. <span style="font-weight: 600;">影片檔案（請以 PDF 上傳，並於檔案中提供連結及 QR Code）</span>Video files (must be uploaded
              as a PDF
              containing an accessible link and QR code)<br />
              5. <span style="font-weight: 600;">其他足以證明優秀表現之文件（PDF）</span>Other documents demonstrating outstanding
              performance
              (PDF)<br />
              上傳限制：Upload Restrictions:<br />
              ● <span style="font-weight: 600;">檔案總數以 4 個為限</span>Maximum of <span style="font-weight: 600;">4
                files</span><br />
              ● <span style="font-weight: 600;">檔案總容量 10MB 以內</span>Total file size must not exceed <span
                style="font-weight: 600;">10 MB</span><br />
              ● 超過容量者，<span style="font-weight: 600;">請輸出紙本於截止日前郵寄至本校</span>If the total size exceeds the limit, please
              <span style="font-weight: 600;">print the documents and mail the hard copies to NTUA before the
                deadline</span><br />
              *系（所）若要求紙本或實體文件（如作品集、推薦函、考試證明、USB、DVD 等），可採郵寄方式繳交，不用上傳。If a department requires additional paper-based or
              physical
              materials (e.g., portfolio, letters of recommendation, test certificates, USB drives, DVDs), such items
              may be
              submitted by postal mail.
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T1_Scholarship_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T1_Scholarship"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T1_Scholarship_name" data-namgtag="1" v-model="T1_Scholarship_name" />
                <input type="hidden" v-model="Apply.T1_Scholarship" id="T1_Scholarship_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>教育部或外交部臺灣獎學金證明請提供(如有)</span>Certificate of Taiwan Scholarship from MOE/ MOFA (if
                available)<span style="color: red; margin-left: 8px;" v-if="Apply.T1_Scholarship_Status === 2">{{
                  Apply.T1_Scholarship_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T1_Scholarship && !Apply.T1_Scholarship.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T1_Scholarship_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T1_Scholarship.includes('data:image')" :src="Apply.T1_Scholarship">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T1_Scholarship" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T1_Scholarship && Apply.T1_Scholarship.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full">
              <label for=""><span><span
                    class="required">*</span>上述資料由台藝大國際處代為下載或申請學校負責老師要彙整紙本作品集郵寄至台藝大，台藝大不保證列印品質與效果。</span>The
                above materials can be downloaded directly by the NTUA Office of International Affairs, or the
                responsible
                coordinator at the home institution may compile the printed portfolios and mail them to NTUA. <span
                  style="font-weight: 600;">Please note that NTUA cannot guarantee the quality or outcome of the printed
                  materials.</span></label>
              <span class="show_preview" v-if="Step == 3">
                {{ Apply.TA_DownloadType == '0' ? '由台藝大下載 Download by the NTUA OIA' : '經由所屬學校老師以紙本郵件寄出 By Post' }}
              </span>
              <div class="check_group" style="margin: 12px 5px; margin-bottom: 0;" v-else>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_NTUA" id="TA_DownloadType_NTUA"
                    value="0" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_NTUA">由台藝大下載 Download by the NTUA OIA</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_Post" id="TA_DownloadType_Post"
                    value="1" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_Post">經由所屬學校老師以紙本郵件寄出 By Post</label>
                </div>
              </div>
            </div>
          </div>
          <div class="box review" v-if="Apply && ApplyType == 2 && Apply.Nationality != 'A00'"
            v-show="Step == 2 || Step == 3">
            <h2>上傳申請文件 Required Documents Upload<span></span></h2>
            <!-- <div class="form-group full">
              <div class="custom_file req_file">
                <input type="file" id="T2_Recommend"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_Recommend_name" data-namgtag="1" v-model="T2_Recommend_name" />
                <input type="hidden" v-model="Apply.T2_Recommend" id="T2_Recommend_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳臺灣藝術大學姊妹校交換生推薦表(.pdf)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>臺灣藝術大學姊妹校交換生推薦表(.pdf)</span>Nomination Form for
                Exchange
                Study (.pdf)</label>
              <template v-if="Step == 3 && Apply.T2_Recommend && !Apply.T2_Recommend.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_Recommend_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_Recommend.includes('data:image')" :src="Apply.T2_Recommend">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_Recommend" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_Recommend && Apply.T2_Recommend.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/nomination_form_for_exchange.xlsx" target="_blank">範本下載
                  Download
                  Template</a>
                <a class="download download_sample" href="files/nomination_form_for_exchange_en.xlsx" target="_blank"
                  style="margin-left: 5px;">Template
                  Download</a>
              </div>
            </div> -->
            <div class="form-group full">
              <label for=""><span><span class="required">*</span>臺灣藝術大學姊妹校交換生推薦表(.pdf)</span>Nomination Form for
                Exchange
                Study (.pdf)</label>
              <div style="padding: 12px 12px;">
                姊妹校學生推薦表電子檔
                應於紙本收件截止日前由推薦學校統一電郵寄至本校，不受理學生自行電郵。郵寄電子郵件至：international@ntua.edu.tw
                <br />
                Submission of the “Nomination Letter for Exchange Study” (electronic file)-Partner institution
                The electronic file must be sent by the partner institution via email to NTUA before the paper document
                submission
                deadline. Emails sent directly by students will not be accepted.
                Please send to: international@ntua.edu.tw
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_Passport_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_Passport"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_Passport_name" data-namgtag="1" v-model="T2_Passport_name" />
                <input type="hidden" v-model="Apply.T2_Passport" id="T2_Passport_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳護照" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>護照</span>Copy of Passport<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_Passport_Status === 2">{{
                    Apply.T2_Passport_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T2_Passport && !Apply.T2_Passport.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_Passport_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_Passport.includes('data:image')" :src="Apply.T2_Passport">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_Passport" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_Passport && Apply.T2_Passport.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_Transcript_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_Transcript"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_Transcript_name" data-namgtag="1" v-model="T2_Transcript_name" />
                <input type="hidden" v-model="Apply.T2_Transcript" id="T2_Transcript_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳歷年成績單" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>歷年成績單</span>Full transcript of current school<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_Transcript_Status === 2">{{
                    Apply.T2_Transcript_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_Transcript && !Apply.T2_Transcript.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_Transcript_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_Transcript.includes('data:image')" :src="Apply.T2_Transcript">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_Transcript" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_Transcript && Apply.T2_Transcript.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_StudentCard_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_StudentCard"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_StudentCard_name" data-namgtag="1" v-model="T2_StudentCard_name" />
                <input type="hidden" v-model="Apply.T2_StudentCard" id="T2_StudentCard_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳學生證" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>學生證</span>Photocopy of student card<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_StudentCard_Status === 2">{{
                    Apply.T2_StudentCard_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_StudentCard && !Apply.T2_StudentCard.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_StudentCard_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_StudentCard.includes('data:image')" :src="Apply.T2_StudentCard">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_StudentCard" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_StudentCard && Apply.T2_StudentCard.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_SelfIntroduction_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_SelfIntroduction"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_SelfIntroduction_name" data-namgtag="1"
                  v-model="T2_SelfIntroduction_name" />
                <input type="hidden" v-model="Apply.T2_SelfIntroduction" id="T2_SelfIntroduction_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳自傳" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>自傳</span>Self-Introduction<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_SelfIntroduction_Status === 2">{{
                    Apply.T2_SelfIntroduction_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_SelfIntroduction && !Apply.T2_SelfIntroduction.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_SelfIntroduction_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_SelfIntroduction.includes('data:image')"
                  :src="Apply.T2_SelfIntroduction">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_SelfIntroduction" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_SelfIntroduction && Apply.T2_SelfIntroduction.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_StudyPlan_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_StudyPlan"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_StudyPlan_name" data-namgtag="1" v-model="T2_StudyPlan_name" />
                <input type="hidden" v-model="Apply.T2_StudyPlan" id="T2_StudyPlan_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality != 'A00' ? '1' : '0'"
                  data-required-msg="請上傳學習計畫書" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>學習計畫書</span>Study Plan<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_StudyPlan_Status === 2">{{
                    Apply.T2_StudyPlan_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_StudyPlan && !Apply.T2_StudyPlan.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_StudyPlan_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_StudyPlan.includes('data:image')" :src="Apply.T2_StudyPlan">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_StudyPlan" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_StudyPlan && Apply.T2_StudyPlan.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_CNProficiencyCert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_CNProficiencyCert"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_CNProficiencyCert_name" data-namgtag="1"
                  v-model="T2_CNProficiencyCert_name" />
                <input type="hidden" v-model="Apply.T2_CNProficiencyCert" id="T2_CNProficiencyCert_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>中文能力證明(如有)</span>Chinese Proficiency Certificate (if available)</label>
              <template
                v-if="Step == 3 && Apply.T2_CNProficiencyCert && !Apply.T2_CNProficiencyCert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_CNProficiencyCert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_CNProficiencyCert.includes('data:image')"
                  :src="Apply.T2_CNProficiencyCert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_CNProficiencyCert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_CNProficiencyCert && Apply.T2_CNProficiencyCert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <!-- <div class="form-group full other_box">
              <div class="custom_file req_file">
                <input type="file" id="T2_Other" accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T2_Other_name" data-namgtag="1" v-model="T2_Other_name" />
                <input type="hidden" v-model="Apply.T2_Other" id="T2_Other_data" />
                <div class="upload">上傳</div>
              </div>
              <input type="text" class="form-control" v-model="Apply.T2_OtherURL" aria-describedby=""
                placeholder="請填寫網址">
              <label for=""><span>其它補充文件(如作品集)</span>Other requirement documents (Ex. Portfolio)</label>
              <template v-if="Step == 3 && Apply.T2_Other && !Apply.T2_Other.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_Other_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_Other.includes('data:image')" :src="Apply.T2_Other">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_Other" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_Other && Apply.T2_Other.includes('/Upload')">下載
                  Download</a>
              </div>
            </div> -->
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores"
                  id="TA_DeptRequiredDocsOrScores_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>系(所)指定文件或考試成績</span>A portfolio of art works that demonstrate the applicant’s artistic
                interest
                and talent (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores && !Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores && Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_2_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_2_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores_2"
                  id="TA_DeptRequiredDocsOrScores_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores_2 && !Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores_2.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores_2 && Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs"
                  id="TA_OtherExcellenceProofDocs_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>其他證明優秀表現之文件</span>Any other relevant experiences and certificates showing the
                applicant’s
                Qualification (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs && !Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs && Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_2_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_2_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs_2"
                  id="TA_OtherExcellenceProofDocs_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs_2 && !Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs_2.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs_2 && Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div style="width: 100%; padding: 12px 16px;">
              申請系統開放上傳下列資料：The application system accepts the following documents:<br />
              1. <span style="font-weight: 600;">中文檢定成績（PDF）</span>Chinese proficiency test score report (PDF)<br />
              2. <span style="font-weight: 600;">作品集（PDF）</span>Portfolio (PDF)<br />
              3. <span style="font-weight: 600;">研究報告（PDF）</span>Research report (PDF)<br />
              4. <span style="font-weight: 600;">影片檔案（請以 PDF 上傳，並於檔案中提供連結及 QR Code）</span>Video files (must be uploaded
              as a PDF
              containing an accessible link and QR code)<br />
              5. <span style="font-weight: 600;">其他足以證明優秀表現之文件（PDF）</span>Other documents demonstrating outstanding
              performance
              (PDF)<br />
              上傳限制：Upload Restrictions:<br />
              ● <span style="font-weight: 600;">檔案總數以 4 個為限</span>Maximum of <span style="font-weight: 600;">4
                files</span><br />
              ● <span style="font-weight: 600;">檔案總容量 10MB 以內</span>Total file size must not exceed <span
                style="font-weight: 600;">10 MB</span><br />
              ● 超過容量者，<span style="font-weight: 600;">請輸出紙本於截止日前郵寄至本校</span>If the total size exceeds the limit, please
              <span style="font-weight: 600;">print the documents and mail the hard copies to NTUA before the
                deadline</span><br />
              *系（所）若要求紙本或實體文件（如作品集、推薦函、考試證明、USB、DVD 等），可採郵寄方式繳交，不用上傳。If a department requires additional paper-based or
              physical
              materials (e.g., portfolio, letters of recommendation, test certificates, USB drives, DVDs), such items
              may be
              submitted by postal mail.
            </div>
            <div class="form-group full">
              <label for=""><span><span
                    class="required">*</span>上述資料由台藝大國際處代為下載或申請學校負責老師要彙整紙本作品集郵寄至台藝大，台藝大不保證列印品質與效果。</span>The
                above materials can be downloaded directly by the NTUA Office of International Affairs, or the
                responsible
                coordinator at the home institution may compile the printed portfolios and mail them to NTUA. <span
                  style="font-weight: 600;">Please note that NTUA cannot guarantee the quality or outcome of the printed
                  materials.</span></label>
              <span class="show_preview" v-if="Step == 3">
                {{ Apply.TA_DownloadType == '0' ? '由台藝大下載 Download by the NTUA OIA' : '經由所屬學校老師以紙本郵件寄出 By Post' }}
              </span>
              <div class="check_group" style="margin: 12px 5px; margin-bottom: 0;" v-else>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_NTUA" id="TA_DownloadType_NTUA"
                    value="0" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_NTUA">由台藝大下載 Download by the NTUA OIA</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_Post" id="TA_DownloadType_Post"
                    value="1" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_Post">經由所屬學校老師以紙本郵件寄出 By Post</label>
                </div>
              </div>
            </div>
          </div>
          <div class="box review-file" v-if="Apply && ApplyType == 2 && Apply.Nationality == 'A00'"
            v-show="Step == 2 || Step == 3">
            <h2>上傳申請文件 Required Documents Upload<span></span></h2>
            <!-- <div class="form-group full">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Recommend"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_C_Recommend_name" data-namgtag="1" v-model="T2_C_Recommend_name" />
                <input type="hidden" v-model="Apply.T2_C_Recommend" id="T2_C_Recommend_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳臺灣藝術大學姊妹校交換生推薦表(.pdf)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>臺灣藝術大學姊妹校交換生推薦表(.pdf)</span>Nomination Form for
                Exchange
                Study (.pdf)</label>
              <template v-if="Step == 3 && Apply.T2_C_Recommend && !Apply.T2_C_Recommend.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Recommend_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Recommend.includes('data:image')" :src="Apply.T2_C_Recommend">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Recommend" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Recommend && Apply.T2_C_Recommend.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/nomination_form_for_exchange.xlsx" target="_blank"
                  style="margin-right: 5px;">範本下載
                  Download
                  Template</a>
                <a class="download download_sample" href="files/nomination_form_for_exchange_en.xlsx"
                  target="_blank">範本下載
                  Download
                  Template</a>
              </div>
            </div> -->
            <div class="form-group full">
              <label for=""><span><span class="required">*</span>臺灣藝術大學姊妹校交換生推薦表(.pdf)</span>Nomination Form for
                Exchange
                Study (.pdf)</label>
              <div style="padding: 12px 12px;">
                姊妹校學生推薦表電子檔
                應於紙本收件截止日前由推薦學校統一電郵寄至本校，不受理學生自行電郵。郵寄電子郵件至：international@ntua.edu.tw
                <br />
                Submission of the “Nomination Letter for Exchange Study” (electronic file)-Partner institution
                The electronic file must be sent by the partner institution via email to NTUA before the paper document
                submission
                deadline. Emails sent directly by students will not be accepted.
                Please send to: international@ntua.edu.tw
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_Passport_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Passport" accept=".jpg" @change="checkFiles">
                <input type="hidden" id="T2_C_Passport_name" data-namgtag="1" v-model="T2_C_Passport_name" />
                <input type="hidden" v-model="Apply.T2_C_Passport" id="T2_C_Passport_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳有效期限內居民身分證彩色正面清晰掃描檔" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>有效期限內居民身分證彩色正面清晰掃描檔</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T2_C_Passport && !Apply.T2_C_Passport.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Passport_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Passport.includes('data:image')" :src="Apply.T2_C_Passport">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Passport" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Passport && Apply.T2_C_Passport.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_Passport_Back_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Passport_Back" accept=".jpg" @change="checkFiles">
                <input type="hidden" id="T2_C_Passport_Back_name" data-namgtag="1" v-model="T2_C_Passport_Back_name" />
                <input type="hidden" v-model="Apply.T2_C_Passport_Back" id="T2_C_Passport_Back_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳有效期限內居民身分證彩色反面清晰掃描檔" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>有效期限內居民身分證彩色反面清晰掃描檔</span><span
                  style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{
                    Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;"
                  v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{
                    Apply.TA_OtherExcellenceProofDocs_2_StatusContent
                  }}</span></label>
              <template v-if="Step == 3 && Apply.T2_C_Passport_Back && !Apply.T2_C_Passport_Back.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Passport_Back_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Passport_Back.includes('data:image')"
                  :src="Apply.T2_C_Passport_Back">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Passport_Back" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Passport_Back && Apply.T2_C_Passport_Back.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_IDPhoto2InWhiteBG_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_IDPhoto2InWhiteBG" accept=".jpg" @change="checkFiles">
                <input type="hidden" id="T2_C_IDPhoto2InWhiteBG_name" data-namgtag="1"
                  v-model="T2_C_IDPhoto2InWhiteBG_name" />
                <input type="hidden" v-model="Apply.T2_C_IDPhoto2InWhiteBG" id="T2_C_IDPhoto2InWhiteBG_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳二吋白底證件照" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>二吋白底證件照(大陸地區人民需嚴格符合要求)</span>One ID photo</label>
              <p>
                大陸地區人民個人照片規格要求: <a
                  href="https://roc-taiwan.org/uploads/sites/45/2024/12/%E5%AE%8C%E6%88%90002-%E7%85%A7%E7%89%87%E8%A6%8F%E6%A0%BCver06.pdf"
                  target="_blank">前往查看說明文件</a> (rule for China students)
              </p>
              <template
                v-if="Step == 3 && Apply.T2_C_IDPhoto2InWhiteBG && !Apply.T2_C_IDPhoto2InWhiteBG.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_IDPhoto2InWhiteBG_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_IDPhoto2InWhiteBG.includes('data:image')"
                  :src="Apply.T2_C_IDPhoto2InWhiteBG">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_IDPhoto2InWhiteBG" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_IDPhoto2InWhiteBG && Apply.T2_C_IDPhoto2InWhiteBG.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <!-- <div class="form-group full">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Access"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_C_Access_name" data-namgtag="1" v-model="T2_C_Access_name" />
                <input type="hidden" v-model="Apply.T2_C_Access" id="T2_C_Access_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳`大陸地區人民入出`臺灣地區申請書(.docx)" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>大陸地區人民入出臺灣地區申請書(.docx)</span><span style="color: red; margin-left: 8px;" v-if="Apply.TA_DeptRequiredDocsOrScores_2_Status === 2">{{ Apply.TA_DeptRequiredDocsOrScores_2_StatusContent }}</span><span style="color: red; margin-left: 8px;" v-if="Apply.TA_OtherExcellenceProofDocs_2_Status === 2">{{ Apply.TA_OtherExcellenceProofDocs_2_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_C_Access && !Apply.T2_C_Access.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Access_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Access.includes('data:image')" :src="Apply.T2_C_Access">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Access" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Access && Apply.T2_C_Access.includes('/Upload')">下載
                  Download</a>
                <a class="download download_sample" href="files/附件3 入出台灣地區申請書.docx" target="_blank">範本下載 Download
                  Template</a>
              </div>
            </div> -->
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_StudyCert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_StudyCert" accept=".jpg" @change="checkFiles">
                <input type="hidden" id="T2_C_StudyCert_name" data-namgtag="1" v-model="T2_C_StudyCert_name" />
                <input type="hidden" v-model="Apply.T2_C_StudyCert" id="T2_C_StudyCert_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳在學證明" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>在學證明</span>Certificate of Enrollment</label>
              <template v-if="Step == 3 && Apply.T2_C_StudyCert && !Apply.T2_C_StudyCert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_StudyCert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_StudyCert.includes('data:image')" :src="Apply.T2_C_StudyCert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_StudyCert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_StudyCert && Apply.T2_C_StudyCert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_Transcript_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Transcript" accept=".jpg,.pdf" @change="checkFiles">
                <input type="hidden" id="T2_C_Transcript_name" data-namgtag="1" v-model="T2_C_Transcript_name" />
                <input type="hidden" v-model="Apply.T2_C_Transcript" id="T2_C_Transcript_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳在校歷年成績單" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>在校歷年成績單</span>Full Academic Record/Transcript</label>
              <template v-if="Step == 3 && Apply.T2_C_Transcript && !Apply.T2_C_Transcript.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Transcript_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Transcript.includes('data:image')"
                  :src="Apply.T2_C_Transcript">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Transcript" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Transcript && Apply.T2_C_Transcript.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_SelfIntroduction_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_SelfIntroduction" accept=".pdf" @change="checkFiles">
                <input type="hidden" id="T2_C_SelfIntroduction_name" data-namgtag="1"
                  v-model="T2_C_SelfIntroduction_name" />
                <input type="hidden" v-model="Apply.T2_C_SelfIntroduction" id="T2_C_SelfIntroduction_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳自傳" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>自傳</span>Self-Introduction<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_SelfIntroduction_Status === 2">{{
                    Apply.T2_SelfIntroduction_StatusContent }}</span></label>
              <template
                v-if="Step == 3 && Apply.T2_C_SelfIntroduction && !Apply.T2_C_SelfIntroduction.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_SelfIntroduction_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_SelfIntroduction.includes('data:image')"
                  :src="Apply.T2_C_SelfIntroduction">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_SelfIntroduction" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_SelfIntroduction && Apply.T2_C_SelfIntroduction.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_StudyPlan_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_StudyPlan" accept=".pdf" @change="checkFiles">
                <input type="hidden" id="T2_C_StudyPlan_name" data-namgtag="1" v-model="T2_C_StudyPlan_name" />
                <input type="hidden" v-model="Apply.T2_C_StudyPlan" id="T2_C_StudyPlan_data"
                  :data-required="Step == 2 && ApplyType == 2 && Apply.Nationality == 'A00' ? '1' : '0'"
                  data-required-msg="請上傳學習計畫書" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span><span class="required">*</span>學習計畫書</span>Study Plan<span
                  style="color: red; margin-left: 8px;" v-if="Apply.T2_StudyPlan_Status === 2">{{
                    Apply.T2_StudyPlan_StatusContent }}</span></label>
              <template v-if="Step == 3 && Apply.T2_C_StudyPlan && !Apply.T2_C_StudyPlan.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_StudyPlan_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_StudyPlan.includes('data:image')" :src="Apply.T2_C_StudyPlan">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_StudyPlan" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_StudyPlan && Apply.T2_C_StudyPlan.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T2_C_ChineseProficiencyCert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_ChineseProficiencyCert" accept=".pdf" @change="checkFiles">
                <input type="hidden" id="T2_C_ChineseProficiencyCert_name" data-namgtag="1"
                  v-model="T2_C_ChineseProficiencyCert_name" />
                <input type="hidden" v-model="Apply.T2_C_ChineseProficiencyCert"
                  id="T2_C_ChineseProficiencyCert_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>非中文母語者上傳中文檢定證明</span>Chinese proficiency certificate (depends on applied department’s
                requirements)</label>
              <template
                v-if="Step == 3 && Apply.T2_C_ChineseProficiencyCert && !Apply.T2_C_ChineseProficiencyCert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_ChineseProficiencyCert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_ChineseProficiencyCert.includes('data:image')"
                  :src="Apply.T2_C_ChineseProficiencyCert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_ChineseProficiencyCert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_ChineseProficiencyCert && Apply.T2_C_ChineseProficiencyCert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <!-- <div class="form-group full other_box">
              <div class="custom_file req_file">
                <input type="file" id="T2_C_Other"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T2_C_Other_name" data-namgtag="1" v-model="T2_C_Other_name" />
                <input type="hidden" v-model="Apply.T2_C_Other" id="T2_C_Other_data" />
                <div class="upload">上傳</div>
              </div>
              <input type="text" class="form-control" v-model="Apply.T2_C_OtherURL" aria-describedby=""
                placeholder="請填寫網址">
              <label for=""><span>其它補充文件(如作品集)</span></label>
              <template v-if="Step == 3 && Apply.T2_C_Other && !Apply.T2_C_Other.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T2_C_Other_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T2_C_Other.includes('data:image')" :src="Apply.T2_C_Other">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T2_C_Other" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T2_C_Other && Apply.T2_C_Other.includes('/Upload')">下載
                  Download</a>
              </div>
            </div> -->
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores"
                  id="TA_DeptRequiredDocsOrScores_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>系(所)指定文件或考試成績</span>A portfolio of art works that demonstrate the applicant’s artistic
                interest
                and talent (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores && !Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores && Apply.TA_DeptRequiredDocsOrScores.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_DeptRequiredDocsOrScores_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_DeptRequiredDocsOrScores_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_DeptRequiredDocsOrScores_2_name" data-namgtag="1"
                  v-model="TA_DeptRequiredDocsOrScores_2_name" />
                <input type="hidden" v-model="Apply.TA_DeptRequiredDocsOrScores_2"
                  id="TA_DeptRequiredDocsOrScores_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_DeptRequiredDocsOrScores_2 && !Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_DeptRequiredDocsOrScores_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_DeptRequiredDocsOrScores_2.includes('data:image')"
                  :src="Apply.TA_DeptRequiredDocsOrScores_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_DeptRequiredDocsOrScores_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_DeptRequiredDocsOrScores_2 && Apply.TA_DeptRequiredDocsOrScores_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs"
                  id="TA_OtherExcellenceProofDocs_data" />
                <div class="upload">上傳</div>
              </div>
              <label for=""><span>其他證明優秀表現之文件</span>Any other relevant experiences and certificates showing the
                applicant’s
                Qualification (Depends on applied department’s requirements)</label>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs && !Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs && Apply.TA_OtherExcellenceProofDocs.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.TA_OtherExcellenceProofDocs_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="TA_OtherExcellenceProofDocs_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="TA_OtherExcellenceProofDocs_2_name" data-namgtag="1"
                  v-model="TA_OtherExcellenceProofDocs_2_name" />
                <input type="hidden" v-model="Apply.TA_OtherExcellenceProofDocs_2"
                  id="TA_OtherExcellenceProofDocs_2_data" />
                <div class="upload">上傳</div>
              </div>
              <template
                v-if="Step == 3 && Apply.TA_OtherExcellenceProofDocs_2 && !Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ TA_OtherExcellenceProofDocs_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.TA_OtherExcellenceProofDocs_2.includes('data:image')"
                  :src="Apply.TA_OtherExcellenceProofDocs_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.TA_OtherExcellenceProofDocs_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.TA_OtherExcellenceProofDocs_2 && Apply.TA_OtherExcellenceProofDocs_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div style="width: 100%; padding: 12px 16px;">
              申請系統開放上傳下列資料：The application system accepts the following documents:<br />
              1. <span style="font-weight: 600;">中文檢定成績（PDF）</span>Chinese proficiency test score report (PDF)<br />
              2. <span style="font-weight: 600;">作品集（PDF）</span>Portfolio (PDF)<br />
              3. <span style="font-weight: 600;">研究報告（PDF）</span>Research report (PDF)<br />
              4. <span style="font-weight: 600;">影片檔案（請以 PDF 上傳，並於檔案中提供連結及 QR Code）</span>Video files (must be uploaded
              as a PDF
              containing an accessible link and QR code)<br />
              5. <span style="font-weight: 600;">其他足以證明優秀表現之文件（PDF）</span>Other documents demonstrating outstanding
              performance
              (PDF)<br />
              上傳限制：Upload Restrictions:<br />
              ● <span style="font-weight: 600;">檔案總數以 4 個為限</span>Maximum of <span style="font-weight: 600;">4
                files</span><br />
              ● <span style="font-weight: 600;">檔案總容量 10MB 以內</span>Total file size must not exceed <span
                style="font-weight: 600;">10 MB</span><br />
              ● 超過容量者，<span style="font-weight: 600;">請輸出紙本於截止日前郵寄至本校</span>If the total size exceeds the limit, please
              <span style="font-weight: 600;">print the documents and mail the hard copies to NTUA before the
                deadline</span><br />
              *系（所）若要求紙本或實體文件（如作品集、推薦函、考試證明、USB、DVD 等），可採郵寄方式繳交，不用上傳。If a department requires additional paper-based or
              physical
              materials (e.g., portfolio, letters of recommendation, test certificates, USB drives, DVDs), such items
              may be
              submitted by postal mail.
            </div>
            <div class="form-group full">
              <label for=""><span><span
                    class="required">*</span>上述資料由台藝大國際處代為下載或申請學校負責老師要彙整紙本作品集郵寄至台藝大，台藝大不保證列印品質與效果。</span>The
                above materials can be downloaded directly by the NTUA Office of International Affairs, or the
                responsible
                coordinator at the home institution may compile the printed portfolios and mail them to NTUA. <span
                  style="font-weight: 600;">Please note that NTUA cannot guarantee the quality or outcome of the printed
                  materials.</span></label>
              <span class="show_preview" v-if="Step == 3">
                {{ Apply.TA_DownloadType == '0' ? '由台藝大下載 Download by the NTUA OIA' : '經由所屬學校老師以紙本郵件寄出 By Post' }}
              </span>
              <div class="check_group" style="margin: 12px 5px; margin-bottom: 0;" v-else>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_NTUA" id="TA_DownloadType_NTUA"
                    value="0" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_NTUA">由台藝大下載 Download by the NTUA OIA</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="TA_DownloadType_Post" id="TA_DownloadType_Post"
                    value="1" v-model="Apply.TA_DownloadType">
                  <label class="form-check-label" style="transform: translateX(0) translateY(0);"
                    for="TA_DownloadType_Post">經由所屬學校老師以紙本郵件寄出 By Post</label>
                </div>
              </div>
            </div>
          </div>
          <div class="box review-file" v-if="Apply && ApplyType == 3" v-show="Step == 2 || Step == 3">
            <h2>上傳申請文件<span></span></h2>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_Recommend_1_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_Recommend_1"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_Recommend_1_name" data-namgtag="1" v-model="T3_Recommend_1_name" />
                <input type="hidden" v-model="Apply.T3_Recommend_1" id="T3_Recommend_1_data"
                  :data-required="Step == 2 && ApplyType == 3 ? '1' : '0'" data-required-msg="請上傳第一封教授推薦函" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>第一封教授推薦函</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Recommend_1 != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Recommend_1 != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Recommend_1)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_Recommend_1 && !Apply.T3_Recommend_1.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_Recommend_1_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_Recommend_1.includes('data:image')" :src="Apply.T3_Recommend_1">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_Recommend_1" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_Recommend_1 && Apply.T3_Recommend_1.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_Recommend_2_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_Recommend_2"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_Recommend_2_name" data-namgtag="1" v-model="T3_Recommend_2_name" />
                <input type="hidden" v-model="Apply.T3_Recommend_2" id="T3_Recommend_2_data"
                  :data-required="Step == 2 && ApplyType == 3 ? '1' : '0'" data-required-msg="請上傳第二封教授推薦函" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>第二封教授推薦函</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Recommend_2 != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Recommend_2 != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Recommend_2)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_Recommend_2 && !Apply.T3_Recommend_2.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_Recommend_2_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_Recommend_2.includes('data:image')" :src="Apply.T3_Recommend_2">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_Recommend_2" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_Recommend_2 && Apply.T3_Recommend_2.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_SelfIntroduction_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_SelfIntroduction"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_SelfIntroduction_name" data-namgtag="1"
                  v-model="T3_SelfIntroduction_name" />
                <input type="hidden" v-model="Apply.T3_SelfIntroduction" id="T3_SelfIntroduction_data"
                  :data-required="Step == 2 && ApplyType == 3 ? '1' : '0'" data-required-msg="請上傳履歷及自傳" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>履歷及自傳</span>
                <div class="instructions" v-show="ApplyData.Event.T3_SelfIntroduction != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_SelfIntroduction != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_SelfIntroduction)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_SelfIntroduction && !Apply.T3_SelfIntroduction.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_SelfIntroduction_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_SelfIntroduction.includes('data:image')"
                  :src="Apply.T3_SelfIntroduction">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_SelfIntroduction" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_SelfIntroduction && Apply.T3_SelfIntroduction.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_StudyPlan_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_StudyPlan"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_StudyPlan_name" data-namgtag="1" v-model="T3_StudyPlan_name" />
                <input type="hidden" v-model="Apply.T3_StudyPlan" id="T3_StudyPlan_data"
                  :data-required="Step == 2 && ApplyType == 3 ? '1' : '0'" data-required-msg="請上傳讀書/研究計畫" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>讀書/研究計畫</span>
                <div class="instructions" v-show="ApplyData.Event.T3_StudyPlan != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_StudyPlan != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_StudyPlan)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_StudyPlan && !Apply.T3_StudyPlan.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_StudyPlan_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_StudyPlan.includes('data:image')" :src="Apply.T3_StudyPlan">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_StudyPlan" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_StudyPlan && Apply.T3_StudyPlan.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full">
              <input type="" class="form-control" v-model="Apply.T3_Other"
                :data-required="Step == 2 && ApplyType == 3 ? '1' : '0'" data-required-msg="請填寫網址" aria-describedby=""
                placeholder="請填寫網址">
              <label for="">
                <span><span class="required">*</span>電子檔作品集線上雲端硬碟連結</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Other != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Other != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Other)">說明</a>
                </div>
              </label>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_Transcript_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_Transcript"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_Transcript_name" data-namgtag="1" v-model="T3_Transcript_name" />
                <input type="hidden" v-model="Apply.T3_Transcript" id="T3_Transcript_data" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>中(英文)成績單</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Transcript != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Transcript != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Transcript)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_Transcript && !Apply.T3_Transcript.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_Transcript_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_Transcript.includes('data:image')" :src="Apply.T3_Transcript">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_Transcript" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_Transcript && Apply.T3_Transcript.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_LangCert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_LangCert"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_LangCert_name" data-namgtag="1" v-model="T3_LangCert_name" />
                <input type="hidden" v-model="Apply.T3_LangCert" id="T3_LangCert_data" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span>語言檢定證明</span>
                <div class="instructions" v-show="ApplyData.Event.T3_LangCert != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_LangCert != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_LangCert)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_LangCert && !Apply.T3_LangCert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_LangCert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_LangCert.includes('data:image')" :src="Apply.T3_LangCert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_LangCert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_LangCert && Apply.T3_LangCert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_Award_Cert_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_Award_Cert"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_Award_Cert_name" data-namgtag="1" v-model="T3_Award_Cert_name" />
                <input type="hidden" v-model="Apply.T3_Award_Cert" id="T3_Award_Cert_data" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span>得獎證明</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Award_Cert != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Award_Cert != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Award_Cert)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_Award_Cert && !Apply.T3_Award_Cert.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_Award_Cert_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_Award_Cert.includes('data:image')" :src="Apply.T3_Award_Cert">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_Award_Cert" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_Award_Cert && Apply.T3_Award_Cert.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
            <div class="form-group full" v-if="fileStatusCheck(Apply.T3_Undertaking_Status)">
              <div class="custom_file req_file">
                <input type="file" id="T3_Undertaking"
                  accept=".bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt" @change="checkFiles">
                <input type="hidden" id="T3_Undertaking_name" data-namgtag="1" v-model="T3_Undertaking_name" />
                <input type="hidden" v-model="Apply.T3_Undertaking" id="T3_Undertaking_data" />
                <div class="upload">上傳</div>
              </div>
              <label for="">
                <span><span class="required">*</span>交換學生計畫應屆畢業生切結書</span>
                <div class="instructions" v-show="ApplyData.Event.T3_Undertaking != -1">
                  <a class="download" href="javascript:void(0)" v-if="ApplyData.Event.T3_Undertaking != -1"
                    @click="gotoPostByPId(ApplyData.Event.T3_Undertaking)">說明</a>
                </div>
              </label>
              <template v-if="Step == 3 && Apply.T3_Undertaking && !Apply.T3_Undertaking.includes('/Upload')">
                <span class="show_preview">
                  已準備上傳, 檔案名稱: <span style="color: red;">{{ T3_Undertaking_name }}</span>
                </span>
                <img class="img_preview" v-if="Apply.T3_Undertaking.includes('data:image')" :src="Apply.T3_Undertaking">
              </template>
              <div class="download_box">
                <a class="download" style="margin-right: 5px; background-color: #1a73e8"
                  :href="ApplyData.SiteUrl + Apply.T3_Undertaking" target="_blank"
                  v-if="Apply.AId != -1 && Apply.T3_Undertaking && Apply.T3_Undertaking.includes('/Upload')">下載
                  Download</a>
              </div>
            </div>
          </div>

          <div class="form_china form_last_check" v-if="Apply" v-show="Step == 3">
            <div class="box">
              <div class="form-group full">
                <label for=""><span><span
                      class="required">*</span>是否學習需要特殊協助是否有任何需要事先安排的學習或支持需求？（例如：課業調整、心理諮商／心理健康支持、或輔助性服務等）若有，請簡要說明您的需求，以便我們評估可提供之資源。</span>Do
                  you have any specific learning or support needs that may require advance arrangements (e.g. academic
                  accommodations, counseling/mental health support, or assistive services)? If yes, please briefly
                  describe your
                  needs below so that we may evaluate available resources.</label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="IsNeedHelp_Y" id="IsNeedHelp_Y" :value="true"
                      v-model="Apply.IsNeedHelp">
                    <label class="form-check-label" for="IsNeedHelp_Y">是</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="IsNeedHelp_N" id="IsNeedHelp_N" :value="false"
                      v-model="Apply.IsNeedHelp">
                    <label class="form-check-label" for="IsNeedHelp_N">否</label>
                  </div>
                </div>
              </div>
              <div class="form-group full" v-if="Apply.IsNeedHelp">
                <input type="text" class="form-control" aria-describedby="" placeholder="請填寫需求簡要說明"
                  data-required-msg="請填寫需求簡要說明" v-model="Apply.IsNeedHelpContent"
                  :data-required="Apply.IsNeedHelp ? '1' : '0'">
                <label for=""><span><span class="required">*</span>需求簡要說明</span>Requirement Description</label>
              </div>
              <div class="form-group full">
                <label for=""><span><span class="required">*</span>我已確認上述資料正確無誤且無任何作假行為</span>I hereby confirm that the
                  above
                  information is accurate and truthful, and that no falsification has occurred.</label>
                <div class="check_group">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" name="ConfirmSubmit" id="ConfirmSubmit"
                      v-model="ConfirmSubmit">
                    <label class="form-check-label" for="ConfirmSubmit">是</label>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <template v-if="Apply">
            <template v-if="ApplyType == 2 && Apply.Nationality == 'A00'">
              <div class="btn_box" v-if="Apply" v-show="Step == 2">
                <button @click="gotoStep(5)">上一步</button>
                <button @click="gotoStep(3)">下一步</button>
              </div>
              <div class="btn_box" v-if="Apply" v-show="Step == 3">
                <button @click="gotoStep(2)">上一步</button>
                <button @click="gotoStep(4)">送件</button>
              </div>
            </template>
            <template v-else>
              <div class="btn_box" v-if="Apply" v-show="Step == 2">
                <button @click="gotoStep(1)">上一步</button>
                <button @click="gotoStep(3)">下一步</button>
              </div>
              <div class="btn_box" v-if="Apply" v-show="Step == 3">
                <button @click="gotoStep(2)">上一步</button>
                <button @click="gotoStep(4)">送件</button>
              </div>
            </template>
          </template>
          <!-- 申請結果 -->
          <div class="box done" v-if="Apply" v-show="Step == 4">
            <h2>報名完成 Application Completed</h2>
            <div class="text_box">
              <p>感謝您的申請，資料已成功送出。您可隨時至「會員中心」查看審核進度。</p>
              <p>Thank you for your application. Your submission has been received successfully. You may check the
                review progress
                at any time in the “Member Center.”</p>
            </div>
            <div class="btn_box">
              <router-link v-if="Apply.ApplyType == 3" :to="{ name: 'ApplyPrint', params: { AId: AId } }"
                tag="button">列印</router-link>
              <router-link :to="{ name: 'Home', params: {} }" tag="button">回首頁 Back to Home</router-link>
              <router-link :to="{ name: 'Member', params: {} }" tag="button">查詢進度 Check Application Status</router-link>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Select2 from 'v-select2-component';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
Vue.use(VueTelInput);

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';

export default {
  i18n,
  name: "Apply",
  components: {
    Head,
    Footer,
    Select2,
    DatePicker
  },
  data() {
    return {
      ApplyInfoData: null,
      ApplyData: null,
      Apply: null,
      local: "zh_tw",
      ApplyType: -1,
      Step: 0,
      AId: -1,

      // 錯誤訊息雙語對照表
      errorMessages: {
        "請填寫中文姓名": "Please Enter Chinese Name",
        "請填寫英文姓名": "Please Enter English Name",
        "請填寫生日(西元年月日)": "Please Enter Date of Birth",
        "請選擇性別": "Please Select Gender",
        "請上傳證件照": "Please Upload ID Photo",
        "請選擇國籍": "Please Select Nationality",
        "請填寫護照號碼": "Please Enter Passport Number",
        "請填寫電子郵件": "Please Enter Email",
        "請填寫居住地址": "Please Enter Address",
        "請填寫姓名": "Please Enter Name",
        "請填寫關係": "Please Enter Relation",
        "請填寫父親姓名": "Please Enter Father's Name",
        "請填寫父親國籍": "Please Enter Father's Nationality",
        "請填寫母親姓名": "Please Enter Mother's Name",
        "請填寫母親國籍": "Please Enter Mother's Nationality",
        "請選擇學歷": "Please Select Education Level",
        "請選擇學校國家": "Please Select School Country",
        "請填寫學校名稱(中文)": "Please Enter School Name in Chinese",
        "請填寫學校名稱(英文)": "Please Enter School Name in English",
        "請填寫就學期間(起)": "Please Enter Study Duration (Start)",
        "請填寫學就學期間(迄)": "Please Enter Study Duration (End)",
        "請填寫系所/主修": "Please Enter Department/Major",
        "請選擇目前就讀學校地區": "Please Select Current School Continent",
        "請選擇目前就讀學校國別": "Please Select Current School Nationality",
        "請選擇學制": "Please Select Program",
        "請填寫系所": "Please Enter Department",
        "請填寫年級": "Please Enter Year in School",
        "請選擇交換時間": "Please Select Exchange Period",
        "請選擇語言能力": "Please Select Language Proficiency",
        "請填寫身分證號": "Please Enter ID Number",
        "請填寫住家電話": "Please Enter Home Phone Number",
        "請填寫通訊地址": "Please Enter Contact Address",
        "請選擇學院": "Please Select College",
        "請選擇系所": "Please Select Department",
        "請選擇學位別": "Please Select Degree Level",
        "請填寫學號": "Please Enter Student Number",
        "請填寫主修/專攻": "Please Enter Major/Specialization",
        "請填寫英文姓名": "Please Enter English Name",
        "請填寫申請系所": "Please Enter Application Department",
        "請填寫修讀期間(起)": "Please Enter Study Duration (Start)",
        "請填寫修讀期間(迄)": "Please Enter Study Duration (End)",
        "請選擇申請年級": "Please Select Application Year",
        "請選擇是否需服兵役": "Please Select Military Service Status",
        "請選擇競賽得獎證明": "Please Select Award Certificate",
        "請填寫測驗名稱": "Please Enter Test Name",
        "請填寫分數": "Please Enter Score",
        "請填寫等級": "Please Enter Level",
        "請填寫考試日期": "Please Enter Test Date",
        "請填寫歷年學業平均成績（各學期加總平均）": "Please Enter Average Academic Score",
        "請填寫歷年班排名/人數": "Please Enter Class Rank/Total",
        "請填寫歷年學業GPA成績": "Please Enter GPA",
        "請填寫身分證字號": "Please Enter ID Number",
        "請選擇出生地": "Please Select Place of Birth",
        "請填寫國籍": "Please Enter Nationality",
        "請填寫他國護(證)照號碼": "Please Enter Other Passport Number",
        "請填他國護(證)照有效期限": "Please Enter Other Passport Expiry Date",
        "請選擇就讀學制": "Please Select Education System",
        "請選擇入學年份": "Please Select Enrollment Year",
        "請填寫所屬學校": "Please Enter School Name",
        "請填寫職業": "Please Enter Occupation",
        "請填寫門牌號碼": "Please Enter House Number",
        "請填寫居住地址": "Please Enter Residential Address",
        "請選擇現住地區": "Please Select Current District",
        "請填寫父親姓名": "Please Enter Father's Name",
        "請選擇父親職業": "Please Select Father's Occupation",
        "請填寫母親姓名": "Please Enter Mother's Name",
        "請選擇母親職業": "Please Select Mother's Occupation",
        "請填寫任職經歷": "Please Enter Employment History",
        "請上傳護照": "Please Upload Passport",
        "請上傳最高學歷或同等學力證明文件、學歷認證相關證明文件(需經外館驗證)": "Please Upload Highest Education Certificate (Must be verified by Taipei Representative Office)",
        "請上傳歷年成績單(需經外館驗證)": "Please Upload Transcript (Must be verified by Taipei Representative Office)",
        "請上傳出生證明(無法繳交者請使用範本)": "Please Upload Birth Certificate (Use template if not available)",
        "請上傳財力證明": "Please Upload Financial Statement",
        "請上傳自傳": "Please Upload Self-Introduction",
        "請上傳學習計畫書": "Please Upload Study Plan",
        "請上傳中文能力證明(TOCFL)": "Please Upload Chinese Proficiency Certificate (TOCFL)",
        "請上傳申請具結書(請見說明)": "Please Upload Declaration (Please see instruction)",
        "請上傳個人資料提供同意書(請見說明)": "Please Upload Personal Data Agreement (Please see instruction)",
        "請上傳臺灣藝術大學姊妹校交換生推薦表(.pdf)": "Please Upload Nomination Form (.pdf)",
        "請上傳歷年成績單": "Please Upload Transcript",
        "請上傳學生證": "Please Upload Student Card",
        "請上傳有效期限內居民身分證彩色正面清晰掃描檔": "Please Upload Color Scan of ID Card Front",
        "請上傳有效期限內居民身分證彩色反面清晰掃描檔": "Please Upload Color Scan of ID Card Back",
        "請上傳二吋白底證件照": "Please Upload 2-inch ID Photo with White Background",
        "請上傳`大陸地區人民入出`臺灣地區申請書(.docx)": "Please Upload Application Form (.docx)",
        "請上傳在學證明": "Please Upload Certificate of Enrollment",
        "請上傳在校歷年成績單": "Please Upload Full Academic Transcript"
      },

      T1_Passport_name: "",
      T1_HighCert_name: "",
      T1_Transcript_name: "",
      T1_BirthCertificate_name: "",
      T1_ProofOfFinancial_name: "",
      T1_SelfIntroduction_name: "",
      T1_StudyPlan_name: "",
      T1_TOCFL_name: "",
      T1_Declaration_name: "",
      T1_PersonalDataAgree_name: "",
      T1_Other_name: "",
      T1_Scholarship_name: "",
      T2_Recommend_name: "",
      T2_Passport_name: "",
      T2_Transcript_name: "",
      T2_StudentCard_name: "",
      T2_SelfIntroduction_name: "",
      T2_StudyPlan_name: "",
      T2_CNProficiencyCert_name: "",
      T2_Other_name: "",
      T2_C_Recommend_name: "",
      T2_C_Passport_name: "",
      T2_C_Passport_Back_name: "",
      T2_C_IDPhoto2InWhiteBG_name: "",
      T2_C_Access_name: "",
      T2_C_StudyCert_name: "",
      T2_C_Transcript_name: "",
      T2_C_SelfIntroduction_name: "",
      T2_C_StudyPlan_name: "",
      T2_C_ChineseProficiencyCert_name: "",
      T2_C_Other_name: "",
      T3_Recommend_1_name: "",
      T3_Recommend_2_name: "",
      T3_SelfIntroduction_name: "",
      T3_StudyPlan_name: "",
      T3_Transcript_name: "",
      T3_LangCert_name: "",
      T3_Award_Cert_name: "",
      T3_Undertaking_name: "",

      TA_DeptRequiredDocsOrScores_name: "",
      TA_DeptRequiredDocsOrScores_2_name: "",
      TA_OtherExcellenceProofDocs_name: "",
      TA_OtherExcellenceProofDocs_2_name: "",

      ConfirmSubmit: false,
    };
  },
  beforeCreate: function () {
  },
  created: function () {
    this.ApplyType = this.$route.params.ApplyType;
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/ApplyInit",
        {
          params: { ApplyType: this.ApplyType },
        }
      )
      .then((response) => {
        this.ApplyInfoData = response.data;
        if (this.ApplyInfoData.Error) {
          let that = this;
          Swal.fire({
            title: "錯誤 WRONG",
            text: this.ApplyInfoData.Error,
            icon: "error",
            allowOutsideClick: false,
            heightAuto: false,
            willClose: () => {
              that.$router.push({
                name: "Home",
              });
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("is_site_lang")) {
      i18n.locale = $cookies.get("is_site_lang");
      this.local = $cookies.get("is_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    gotoStep(step) {
      if (this.Step == 0 && step == 1) {
        if (!$cookies.isKey("is_login_token")) {
          Swal.fire({
            title: "請先登入帳號<br>Please Login First",
            icon: "info",
            allowOutsideClick: false,
            heightAuto: false,
            willClose: () => {
              this.$router.push({
                name: "Login",
              });
            },
          });
          return;
        }
        Vue.axios
          .get(
            this.$store.state.src +
            this.$store.state.subDirectory +
            "/Html/Apply",
            {
              params: { AId: this.$route.params.AId, ApplyType: this.ApplyType, token: $cookies.get("is_login_token") },
            }
          )
          .then((response) => {
            this.ApplyData = response.data;
            if (this.ApplyData.Error) {
              let that = this;
              Swal.fire({
                title: "錯誤 WRONG",
                text: this.ApplyData.Error,
                icon: "error",
                allowOutsideClick: false,
                heightAuto: false,
                willClose: () => {
                  that.$router.push({
                    name: "Home",
                  });
                },
              });
            } else {
              this.Apply = this.ApplyData.Apply;

              // 初始化布林值屬性
              if (this.Apply.TC_HasOtherNationalityPassport === undefined || this.Apply.TC_HasOtherNationalityPassport === null) {
                this.Apply.TC_HasOtherNationalityPassport = false;
              }

              if (this.Apply != -1 && this.Apply.ApplyType != this.ApplyType) {
                let that = this;
                Swal.fire({
                  title: "錯誤 WRONG",
                  html: "申請表類型不符合<br>Application Type Mismatch",
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: "確定 COMFIRM",
                  heightAuto: false,
                  willClose: () => {
                    that.$router.push({
                      name: "Home",
                    });
                  },
                });
              }
              if (this.Apply.Birthday) {
                this.Apply.Birthday = this.convertDatetimeString(
                  this.Apply.Birthday,
                  "YYYY/MM/DD"
                );
              } else {
                this.Apply.Birthday = "";
              }
              if (this.Apply.T1_StudyDurationStart) {
                this.Apply.T1_StudyDurationStart = this.convertDatetimeString(
                  this.Apply.T1_StudyDurationStart,
                  "YYYY/MM"
                );
              } else {
                this.Apply.T1_StudyDurationStart = "";
              }
              if (this.Apply.T1_StudyDurationEnd) {
                this.Apply.T1_StudyDurationEnd = this.convertDatetimeString(
                  this.Apply.T1_StudyDurationEnd,
                  "YYYY/MM"
                );
              } else {
                this.Apply.T1_StudyDurationEnd = "";
              }
              if (this.Apply.T3_Birthday) {
                this.Apply.T3_Birthday = this.convertDatetimeString(
                  this.Apply.T3_Birthday,
                  "YYYY/MM/DD"
                );
              } else {
                this.Apply.T3_Birthday = "";
              }
              if (this.Apply.T3_StudyDurationStart) {
                this.Apply.T3_StudyDurationStart = this.convertDatetimeString(
                  this.Apply.T3_StudyDurationStart,
                  "YYYY/MM"
                );
              } else {
                this.Apply.T3_StudyDurationStart = "";
              }
              if (this.Apply.T3_StudyDurationEnd) {
                this.Apply.T3_StudyDurationEnd = this.convertDatetimeString(
                  this.Apply.T3_StudyDurationEnd,
                  "YYYY/MM"
                );
              } else {
                this.Apply.T3_StudyDurationEnd = "";
              }
              if (this.Apply.TC_OtherPassportExpiryDate) {
                this.Apply.TC_OtherPassportExpiryDate = this.convertDatetimeString(
                  this.Apply.TC_OtherPassportExpiryDate,
                  "YYYY/MM/DD"
                );
              } else {
                this.Apply.TC_OtherPassportExpiryDate = "";
              }
              if (this.Apply.TC_FatherBirthday) {
                this.Apply.TC_FatherBirthday = this.convertDatetimeString(
                  this.Apply.TC_FatherBirthday,
                  "YYYY/MM/DD"
                );
              } else {
                this.Apply.TC_FatherBirthday = "";
              }
              if (this.Apply.TC_MotherBirthday) {
                this.Apply.TC_MotherBirthday = this.convertDatetimeString(
                  this.Apply.TC_MotherBirthday,
                  "YYYY/MM/DD"
                );
              } else {
                this.Apply.TC_MotherBirthday = "";
              }

              // 若沒有選擇學校地區或國家，清空學校名稱
              if (!this.Apply.T2_SchoolContinent) {
                this.Apply.T2_SchoolContinent = "";
              }
              if (!this.Apply.T2_SchoolCountry) {
                this.Apply.T2_SchoolCountry = "";
              }
              if (!this.Apply.T2_SchoolContinent &&
                !this.Apply.T2_SchoolCountry
              ) {
                this.Apply.T2_SchoolName = "";
              }

              if (this.Apply.TC_EducationSystem != this.Apply.T2_SchoolProgram) {
                this.Apply.TC_EducationSystem = this.Apply.T2_SchoolProgram;
              }
              if (this.Apply.TC_SchoolName != this.Apply.T2_SchoolName) {
                this.Apply.TC_SchoolName = this.Apply.T2_SchoolName;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
        this.Step = 1;
        $('html,body').animate({ scrollTop: 0 }, 0);
      } else if (this.Step == 1 && (step == 2 || step == 5)) {
        var hasError = false;
        var that = this;
        $("[data-required='1']:not(.form_china [data-required='1'])").each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            var msg = input.data("required-msg");
            var enMsg = that.errorMessages[msg] || msg;
            Swal.fire({
              title: "錯誤 WRONG",
              html: msg + "<br>" + enMsg,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "email" &&
            !Validate.reg_email(input.val())) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "Email格式錯誤<br>Invalid Email Format",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        if (this.ApplyType == 3) {
          // 把英文姓名組合後帶到this.Apply.Name_EN
          this.Apply.Name_EN = (this.Apply.T3_Name_EN_First ? this.Apply.T3_Name_EN_First : "") + (this.Apply.T3_Name_EN_Last ? " " + this.Apply.T3_Name_EN_Last : "");
        }
        if (!this.validateEnglishName(this.Apply.Name_EN)) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "英文姓名格式錯誤，請填寫與護照相同之姓名，限大寫英文字母、逗號、空白及橫槓<br>Invalid English Name Format. Please enter the name exactly as shown on your passport. Only uppercase letters, commas, spaces, and hyphens are allowed.",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          return;
        }
        if (this.ApplyType == 2) {
          if (!this.Apply.T2_SchoolCountry) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請選擇目前就讀學校國別<br>Please Select Current School Nationality",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
          if (!this.Apply.T2_SchoolName) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請選擇目前就讀學校<br>Please Select Current School",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
        }
        if (this.ApplyType != 3) {
          if (!this.$refs.Phone.phoneObject.valid ||
            !this.$refs.EmergencyPhone.phoneObject.valid) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請填寫電話號碼<br>Please Enter Phone Number",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
          if (!this.Apply.Program) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請選擇系所<br>Please Select Department",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
          if (!this.Apply.Nationality) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請選擇國籍<br>Please Select Nationality",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
        } else {
          if (!this.$refs.T3_Phone.phoneObject.valid) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請填寫電話號碼<br>Please Enter Phone Number",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
          if (!this.Apply.T3_ApplySchool) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "請選擇申請學校<br>Please Select Application School",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            return;
          }
        }
        if (this.ApplyType == 1 && !this.Apply.T1_CountryOfSchool) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "請選擇學校國家<br>Please Select School Country",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          return;
        }
        this.Step = step;
        $('html,body').animate({ scrollTop: 0 }, 0);
      } else if (this.Step == 5 && step == 2) {
        var hasError = false;
        if (!this.Apply.TC_DeclareTruthResponsibility) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "請勾選「以上所填內容,俱屬事實,如有捏造或虛假情事,願負法律責任。」<br>Please check 'The above information is true and accurate. I am willing to bear legal responsibility for any false or fabricated information.'",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
        var that = this;
        $(".form_china [data-required='1']").each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            var msg = input.data("required-msg");
            var enMsg = that.errorMessages[msg] || msg;
            Swal.fire({
              title: "錯誤 WRONG",
              html: msg + "<br>" + enMsg,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "email" &&
            !Validate.reg_email(input.val())) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "Email格式錯誤<br>Invalid Email Format",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        if (!this.validateChinaIDNumber(this.Apply.TC_IDNumber)) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "身分證字號格式錯誤<br>Invalid ID Number Format",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          return;
        }
        if (!this.Apply.TC_BirthPlace) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "請選擇出生地<br>Please Select Place of Birth",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          return;
        }
        if (!this.$refs.TC_ResidentialMobile.phoneObject.valid ||
          (!this.Apply.TC_FatherDead && !this.$refs.TC_FatherPhone.phoneObject.valid) ||
          (!this.Apply.TC_MotherDead && !this.$refs.TC_MotherPhone.phoneObject.valid)) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "請填寫電話號碼<br>Please Enter Phone Number",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          return;
        }
        this.Step = 2;
        $('html,body').animate({ scrollTop: 0 }, 0);
      } else if ((this.Step == 2 || this.Step == 5) && step == 3) {
        var hasError = false;
        var selecter = "";
        if (this.Step == 2) {
          selecter = "[data-required='1']:not(.form_china [data-required='1'])";
        } else if (this.Step == 5) {
          selecter = ".form_china [data-required='1']";
        }
        var that = this;
        $(selecter).each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            var msg = input.data("required-msg");
            var enMsg = that.errorMessages[msg] || msg;
            Swal.fire({
              title: "錯誤 WRONG",
              html: msg + "<br>" + enMsg,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        this.Step = 3;
        $('html,body').animate({ scrollTop: 0 }, 0);
      } else if (this.Step == 3 && step == 4) {
        var hasError = false;
        if (!this.ConfirmSubmit) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "請勾選「我已確認上述資料正確無誤且無任何作假行為」<br>Please check 'I hereby confirm that the above information is accurate and truthful, and that no falsification has occurred.'",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
        var that = this;
        $(".form_last_check [data-required='1']").each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            var msg = input.data("required-msg");
            var enMsg = that.errorMessages[msg] || msg;
            Swal.fire({
              title: "錯誤 WRONG",
              html: msg + "<br>" + enMsg,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "email" &&
            !Validate.reg_email(input.val())) {
            Swal.fire({
              title: "錯誤 WRONG",
              html: "Email格式錯誤<br>Invalid Email Format",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        Swal.fire({
          title: "請稍候...<br>Please Wait...",
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        // 儲存檔案名稱
        var AttachmentNames = "";
        $("[data-namgtag='1']").each(function () {
          if (AttachmentNames.length > 0) { AttachmentNames += ", "; } else { AttachmentNames += "{"; }
          var input = $(this);
          AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
        });
        AttachmentNames += "}";
        $.ajax({
          url:
            that.$store.state.src +
            that.$store.state.subDirectory +
            "/Html/Apply",
          type: "post",
          data: {
            ApplyJson: JSON.stringify(this.Apply),
            AttachmentNames: AttachmentNames,
            token: $cookies.get("is_login_token")
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            if (res.ok) {
              // Swal.fire({
              //   title: "申請已送出",
              //   icon: "success",
              //   allowOutsideClick: false,
              //   showConfirmButton: false,
              //   heightAuto: false,
              //   timer: 1500,
              //   willClose: () => {
              //     that.$router.push({
              //       name: "Member",
              //     });
              //   },
              // });
              that.AId = res.AId;
              that.Step = 4;
              Swal.close();
              $('html,body').animate({ scrollTop: 0 }, 0);
            } else if (res.error) {
              Swal.fire({
                title: "錯誤 WRONG",
                text: res.error,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: "確定 COMFIRM",
                heightAuto: false,
              });
            }
          }
        });
      } else {
        this.Step = step;
        $('html,body').animate({ scrollTop: 0 }, 0);
      }

      if (this.Step == 3) {
        $(".review").css("pointer-events", "none");
        $(".review-file .custom_file.req_file").css("display", "none");
        $(".review-file .download_sample").css("display", "none");
        $(".review-file input").css("pointer-events", "none");
      } else {
        $(".review").css("pointer-events", "auto");
        $(".review-file .custom_file.req_file").css("display", "block");
        $(".review-file .download_sample").css("display", "unset");
        $(".review-file input").css("pointer-events", "auto");
      }
    },
    setImage(id, rst) {
      $("#" + id + "_preview").attr("src", rst);
      $("#" + id + "_preview").css('opacity', '1');
      $("#" + id + "_data").val(rst);
      Swal.close();
    },
    previewFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: "請稍候...",
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 10485760) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "檔案大小超過10MB",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            $("#" + id).val("");
            if (id == "Photo") {
              that.Apply.Photo = reader.result;
            }
            that.setImage(id, reader.result);
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: "錯誤 WRONG",
              html:
                "處理圖片過程發生錯誤:<br>An error occurred while processing the image:<br />" +
                error +
                "<br />若持續發生此問題請聯繫客服人員, 造成不便敬請見諒<br>If this issue persists, please contact customer service. We apologize for any inconvenience.",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: "請稍候...",
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 10485760) {
          Swal.fire({
            title: "錯誤 WRONG",
            html: "檔案大小超過10MB",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定 COMFIRM",
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T1_Passport") {
              that.Apply.T1_Passport = reader.result;
              that.T1_Passport_name = file.name;
            } else if (id == "T1_HighCert") {
              that.Apply.T1_HighCert = reader.result;
              that.T1_HighCert_name = file.name;
            } else if (id == "T1_Transcript") {
              that.Apply.T1_Transcript = reader.result;
              that.T1_Transcript_name = file.name;
            } else if (id == "T1_BirthCertificate") {
              that.Apply.T1_BirthCertificate = reader.result;
              that.T1_BirthCertificate_name = file.name;
            } else if (id == "T1_ProofOfFinancial") {
              that.Apply.T1_ProofOfFinancial = reader.result;
              that.T1_ProofOfFinancial_name = file.name;
            } else if (id == "T1_SelfIntroduction") {
              that.Apply.T1_SelfIntroduction = reader.result;
              that.T1_SelfIntroduction_name = file.name;
            } else if (id == "T1_StudyPlan") {
              that.Apply.T1_StudyPlan = reader.result;
              that.T1_StudyPlan_name = file.name;
            } else if (id == "T1_TOCFL") {
              that.Apply.T1_TOCFL = reader.result;
              that.T1_TOCFL_name = file.name;
            } else if (id == "T1_Declaration") {
              that.Apply.T1_Declaration = reader.result;
              that.T1_Declaration_name = file.name;
            } else if (id == "T1_PersonalDataAgree") {
              that.Apply.T1_PersonalDataAgree = reader.result;
              that.T1_PersonalDataAgree_name = file.name;
            } else if (id == "T1_Other") {
              that.Apply.T1_Other = reader.result;
              that.T1_Other_name = file.name;
            } else if (id == "T1_Scholarship") {
              that.Apply.T1_Scholarship = reader.result;
              that.T1_Scholarship_name = file.name;
            } else if (id == "T2_Recommend") {
              that.Apply.T2_Recommend = reader.result;
              that.T2_Recommend_name = file.name;
            } else if (id == "T2_Passport") {
              that.Apply.T2_Passport = reader.result;
              that.T2_Passport_name = file.name;
            } else if (id == "T2_Transcript") {
              that.Apply.T2_Transcript = reader.result;
              that.T2_Transcript_name = file.name;
            } else if (id == "T2_StudentCard") {
              that.Apply.T2_StudentCard = reader.result;
              that.T2_StudentCard_name = file.name;
            } else if (id == "T2_SelfIntroduction") {
              that.Apply.T2_SelfIntroduction = reader.result;
              that.T2_SelfIntroduction_name = file.name;
            } else if (id == "T2_StudyPlan") {
              that.Apply.T2_StudyPlan = reader.result;
              that.T2_StudyPlan_name = file.name;
            } else if (id == "T2_CNProficiencyCert") {
              that.Apply.T2_CNProficiencyCert = reader.result;
              that.T2_CNProficiencyCert_name = file.name;
            } else if (id == "T2_Other") {
              that.Apply.T2_Other = reader.result;
              that.T2_Other_name = file.name;
            } else if (id == "T2_C_Recommend") {
              that.Apply.T2_C_Recommend = reader.result;
              that.T2_C_Recommend_name = file.name;
            } else if (id == "T2_C_Passport") {
              that.Apply.T2_C_Passport = reader.result;
              that.T2_C_Passport_name = file.name;
            } else if (id == "T2_C_Passport_Back") {
              that.Apply.T2_C_Passport_Back = reader.result;
              that.T2_C_Passport_Back_name = file.name;
            } else if (id == "T2_C_IDPhoto2InWhiteBG") {
              that.Apply.T2_C_IDPhoto2InWhiteBG = reader.result;
              that.T2_C_IDPhoto2InWhiteBG_name = file.name;
            } else if (id == "T2_C_Access") {
              that.Apply.T2_C_Access = reader.result;
              that.T2_C_Access_name = file.name;
            } else if (id == "T2_C_StudyCert") {
              that.Apply.T2_C_StudyCert = reader.result;
              that.T2_C_StudyCert_name = file.name;
            } else if (id == "T2_C_Transcript") {
              that.Apply.T2_C_Transcript = reader.result;
              that.T2_C_Transcript_name = file.name;
            } else if (id == "T2_C_SelfIntroduction") {
              that.Apply.T2_C_SelfIntroduction = reader.result;
              that.T2_C_SelfIntroduction_name = file.name;
            } else if (id == "T2_C_StudyPlan") {
              that.Apply.T2_C_StudyPlan = reader.result;
              that.T2_C_StudyPlan_name = file.name;
            } else if (id == "T2_C_ChineseProficiencyCert") {
              that.Apply.T2_C_ChineseProficiencyCert = reader.result;
              that.T2_C_ChineseProficiencyCert_name = file.name;
            } else if (id == "T2_C_Other") {
              that.Apply.T2_C_Other = reader.result;
              that.T2_C_Other_name = file.name;
            } else if (id == "T3_Recommend_1") {
              that.Apply.T3_Recommend_1 = reader.result;
              that.T3_Recommend_1_name = file.name;
            } else if (id == "T3_Recommend_2") {
              that.Apply.T3_Recommend_2 = reader.result;
              that.T3_Recommend_2_name = file.name;
            } else if (id == "T3_SelfIntroduction") {
              that.Apply.T3_SelfIntroduction = reader.result;
              that.T3_SelfIntroduction_name = file.name;
            } else if (id == "T3_StudyPlan") {
              that.Apply.T3_StudyPlan = reader.result;
              that.T3_StudyPlan_name = file.name;
            } else if (id == "T3_Transcript") {
              that.Apply.T3_Transcript = reader.result;
              that.T3_Transcript_name = file.name;
            } else if (id == "T3_LangCert") {
              that.Apply.T3_LangCert = reader.result;
              that.T3_LangCert_name = file.name;
            } else if (id == "T3_Award_Cert") {
              that.Apply.T3_Award_Cert = reader.result;
              that.T3_Award_Cert_name = file.name;
            } else if (id == "T3_Undertaking") {
              that.Apply.T3_Undertaking = reader.result;
              that.T3_Undertaking_name = file.name;
            } else if (id == "TA_DeptRequiredDocsOrScores") {
              that.Apply.TA_DeptRequiredDocsOrScores = reader.result;
              that.TA_DeptRequiredDocsOrScores_name = file.name;
            } else if (id == "TA_DeptRequiredDocsOrScores_2") {
              that.Apply.TA_DeptRequiredDocsOrScores_2 = reader.result;
              that.TA_DeptRequiredDocsOrScores_2_name = file.name;
            } else if (id == "TA_OtherExcellenceProofDocs") {
              that.Apply.TA_OtherExcellenceProofDocs = reader.result;
              that.TA_OtherExcellenceProofDocs_name = file.name;
            } else if (id == "TA_OtherExcellenceProofDocs_2") {
              that.Apply.TA_OtherExcellenceProofDocs_2 = reader.result;
              that.TA_OtherExcellenceProofDocs_2_name = file.name;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: "錯誤 WRONG",
              html:
                "處理檔案過程發生錯誤:<br>An error occurred while processing the file:<br />" +
                error +
                "<br />若持續發生此問題請聯繫客服人員, 造成不便敬請見諒<br>If this issue persists, please contact customer service. We apologize for any inconvenience.",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定 COMFIRM",
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    gotoPostByPId: function (PId) {
      const routeData = this.$router.resolve({
        name: "Post",
        params: { PId: PId },
      });
      window.open(routeData.href, '_blank');
    },
    selectedText: function (id, list) {
      if (!id || !list) {
        return '';
      }
      const show_item = list.find(dept => dept.id === id);
      return show_item ? show_item.text : id;
    },
    updateEnrollmentDate() {
      // 這個方法在選擇年份時被觸發，可以在這裡添加額外的邏輯
      // 目前年份已經自動格式化為 "YYYY-09-01" 格式
    },
    formatEnglishName(event) {
      // 允許大寫英文字母、空白、逗號和橫槓
      let value = event.target.value;
      // 移除不符合規則的字符（非大寫英文字母、空白、逗號、橫槓）
      let filteredValue = value.replace(/[^A-Z\s,\-]/g, '');
      // 將小寫字母轉為大寫
      filteredValue = filteredValue.replace(/[a-z]/g, (match) => match.toUpperCase());
      // 更新v-model的值
      console.log("Formatted English Name:", filteredValue);
      this.Apply.Name_EN = filteredValue;
      // 如果輸入值被修改，更新input的值
      if (value !== filteredValue) {
        event.target.value = filteredValue;
      }
    },
    formatEnglishNameFirst(event) {
      // 允許大寫英文字母、空白、逗號和橫槓
      let value = event.target.value;
      // 移除不符合規則的字符（非大寫英文字母、空白、逗號、橫槓）
      let filteredValue = value.replace(/[^A-Z\s,\-]/g, '');
      // 將小寫字母轉為大寫
      filteredValue = filteredValue.replace(/[a-z]/g, (match) => match.toUpperCase());
      // 更新v-model的值
      console.log("Formatted English Name:", filteredValue);
      this.Apply.T3_Name_EN_First = filteredValue;
      // 如果輸入值被修改，更新input的值
      if (value !== filteredValue) {
        event.target.value = filteredValue;
      }
    },
    formatEnglishNameLast(event) {
      // 允許大寫英文字母、空白、逗號和橫槓
      let value = event.target.value;
      // 移除不符合規則的字符（非大寫英文字母、空白、逗號、橫槓）
      let filteredValue = value.replace(/[^A-Z\s,\-]/g, '');
      // 將小寫字母轉為大寫
      filteredValue = filteredValue.replace(/[a-z]/g, (match) => match.toUpperCase());
      // 更新v-model的值
      console.log("Formatted English Name:", filteredValue);
      this.Apply.T3_Name_EN_Last = filteredValue;
      // 如果輸入值被修改，更新input的值
      if (value !== filteredValue) {
        event.target.value = filteredValue;
      }
    },
    validateEnglishName(name) {
      console.log("Validating English Name:", name);

      // 檢查是否為空或只有空白
      if (!name || name.trim() === '') {
        console.log("Validation failed: empty or only whitespace");
        return false;
      }

      // 只檢查是否只包含大寫英文字母、逗號、空白及橫槓
      const validPattern = /^[A-Z,\s\-]+$/;
      if (!validPattern.test(name)) {
        console.log("Validation failed: contains invalid characters");
        return false;
      }

      // 檢查是否至少包含一個字母（不能只有符號）
      if (!/[A-Z]/.test(name)) {
        console.log("Validation failed: does not contain any letters");
        return false;
      }

      console.log("Validation passed");
      return true;
    },
    formatChinaIDNumber(event) {
      // 只允許數字和字母X
      let value = event.target.value;
      // 移除不符合規則的字符（非數字和X）
      let filteredValue = value.replace(/[^0-9Xx]/g, '');
      // 將小寫x轉為大寫X
      filteredValue = filteredValue.replace(/x/g, 'X');
      // 限制長度為18位
      if (filteredValue.length > 18) {
        filteredValue = filteredValue.substring(0, 18);
      }
      // 更新v-model的值
      this.Apply.TC_IDNumber = filteredValue;
      // 如果輸入值被修改，更新input的值
      if (value !== filteredValue) {
        event.target.value = filteredValue;
      }
    },
    validateChinaIDNumber(idNumber) {
      // 檢查是否為空
      if (!idNumber) {
        return false;
      }

      // 檢查格式：18位數字，最後一位可以是X
      const idPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
      if (!idPattern.test(idNumber)) {
        return false;
      }

      // 校驗碼計算
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

      let sum = 0;
      for (let i = 0; i < 17; i++) {
        sum += parseInt(idNumber.charAt(i)) * weights[i];
      }

      const remainder = sum % 11;
      const expectedCheckCode = checkCodes[remainder];

      // 檢查校驗碼是否正確
      if (idNumber.charAt(17) !== expectedCheckCode) {
        return false;
      }

      // 檢查生日是否與Apply.Birthday一致
      if (this.Apply.Birthday) {
        const birthYear = idNumber.substring(6, 10);
        const birthMonth = idNumber.substring(10, 12);
        const birthDay = idNumber.substring(12, 14);
        const idBirthDate = `${birthYear}-${birthMonth}-${birthDay}`;

        const formattedBirthday = this.Apply.Birthday.replace(/\//g, "-");
        if (formattedBirthday !== idBirthDate) {
          return false;
        }
      }

      return true;
    },
    fileStatusCheck(status) {
      if (this.Apply.ApprovalStatus == 0) {
        return true;
      } else if (this.Apply.ApprovalStatus == 2) {
        if (status === 2) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  watch: {
    // 監聽教育系統的變化
    'Apply.TC_EducationSystem': function (newValue, oldValue) {
      if (this.Apply) {
        if (newValue === '大學部') {
          // 當選擇大學部時，學歷自動設為高中
          this.Apply.TC_Education = '高中';
        }
        // 如果選擇其他選項，則保持原來的值或允許自由選擇
      }
    },
    // 監聽大洲選擇的變化，當大洲改變時清空學校選擇
    'Apply.T2_SchoolContinent': function (newValue, oldValue) {
      if (this.Apply && oldValue && newValue !== oldValue) {
        // 清空學校選擇，讓使用者重新選擇
        this.Apply.T2_SchoolCountry = '';
      }
    },
    'Apply.T2_SchoolCountry': function (newValue, oldValue) {
      if (this.Apply && oldValue && newValue !== oldValue) {
        // 清空學校選擇，讓使用者重新選擇
        this.Apply.T2_SchoolName = '';
      }
    },
    // 監聽國籍變化，更新所有電話欄位的國家代碼
    'Apply.Nationality': function (newValue, oldValue) {
      const countryCode = newValue === 'A00' ? 'CN' : 'TW';

      // 更新所有電話欄位的國家代碼
      const phoneRefs = ['Phone', 'EmergencyPhone', 'T3_Phone', 'TC_ResidentialMobile', 'TC_FatherPhone', 'TC_MotherPhone'];

      this.$nextTick(() => {
        phoneRefs.forEach(refName => {
          if (this.$refs[refName] && typeof this.$refs[refName].choose === 'function') {
            this.$refs[refName].choose(countryCode);
          }
        });
      });
    },
    'Apply.T2_SchoolProgram': function (newValue, oldValue) {
      if (this.Apply) {
        this.Apply.TC_EducationSystem = newValue;
      }
    },
    'Apply.T2_SchoolName': function (newValue, oldValue) {
      if (this.Apply) {
        this.Apply.TC_SchoolName = newValue;
      }
    }
  },
  computed: {
    phoneDefaultCountry() {
      // 根據國籍動態設置電話預設國家代碼
      // A00 是中國大陸,使用 CN (86)
      // 其他國籍使用 TW (886)
      if (this.Apply && this.Apply.Nationality === 'A00') {
        return 'CN';
      }
      return 'TW';
    },
    enrollmentYears() {
      //const currentYear = new Date().getFullYear();
      const years = [];
      // 提供過去5年到未來5年的選項
      for (let year = 2020; year <= 2020 + 10; year++) {
        years.push(year);
      }
      return years;
    },
    filteredContractSchools() {
      if (!this.ApplyData || !this.ApplyData.ContractSchoolsForApply || !this.Apply) {
        return [];
      }

      // 如果沒有選擇大洲，返回空陣列
      if (!this.Apply.T2_SchoolContinent) {
        return [];
      }

      // 如果沒有選擇國家，返回空陣列
      if (!this.Apply.T2_SchoolCountry) {
        return [];
      }

      // 根據選擇的大洲篩選學校
      return this.ApplyData.ContractSchoolsForApply
        .filter(school => school.Continent === this.Apply.T2_SchoolContinent && school.Country === this.Apply.T2_SchoolCountry)
        .map(school => ({
          id: school.SchoolName.trim(), // 使用SchoolName作為id
          text: school.SchoolName.trim() + "(" + school.SchoolName_EN.trim() + ")" // 移除可能的tab字符並作為顯示文字
        }));
    },
    filteredContinentCountry() {
      if (!this.ApplyData || !this.ApplyData.CountrysForApply || !this.Apply) {
        return [];
      }

      // 如果沒有選擇大洲，返回空陣列
      if (!this.Apply.T2_SchoolContinent) {
        return [];
      }

      // 根據選擇的大洲篩選國別
      return this.ApplyData.CountrysForApply
        .filter(country => country.Continent === this.Apply.T2_SchoolContinent)
        .map(country => ({
          id: country.id,
          text: country.text
        }));
    }
  },
};
</script>

<style scoped>
/* 當 Step = 3 時，將所有表單控制項樣式改為類似 label 的藍色文字 */
.review[style*="pointer-events: none"] input.form-control,
.review[style*="pointer-events: none"] select.form-control,
.review[style*="pointer-events: none"] .vue-tel-input input,
.review[style*="pointer-events: none"] .select2-container .select2-selection,
.review[style*="pointer-events: none"] .select2-container .select2-selection__rendered {
  border: none !important;
  background: transparent !important;
  color: #007bff !important;
  font-weight: normal !important;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  cursor: default !important;
  pointer-events: none !important;
  font-size: 1.25rem;
}

/* 隱藏 placeholder 文字 */
/* .review[style*="pointer-events: none"] input.form-control::placeholder,
.review[style*="pointer-events: none"] .vue-tel-input input::placeholder {
  color: transparent !important;
  opacity: 0 !important;
} */

/* 隱藏 Select2 的下拉箭頭和相關元素 */
.review[style*="pointer-events: none"] .select2-container .select2-selection__arrow,
.review[style*="pointer-events: none"] .select2-container .select2-selection__clear {
  display: none !important;
}

/* 隱藏一般 select 的下拉箭頭 */
.review[style*="pointer-events: none"] select.form-control {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  background-image: none !important;
}

/* 隱藏日期輸入框的日曆圖示 */
.review[style*="pointer-events: none"] input[type="month"],
.review[style*="pointer-events: none"] input[type="date"],
.review[style*="pointer-events: none"] input[type="datetime-local"],
.review[style*="pointer-events: none"] .mx-datepicker {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

.review[style*="pointer-events: none"] input[type="month"]::-webkit-calendar-picker-indicator,
.review[style*="pointer-events: none"] input[type="date"]::-webkit-calendar-picker-indicator,
.review[style*="pointer-events: none"] input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  display: none !important;
  opacity: 0 !important;
}

/* 隱藏 vue2-datepicker 的圖示 */
.review[style*="pointer-events: none"] .mx-datepicker .mx-input-wrapper .mx-icon-calendar,
.review[style*="pointer-events: none"] .mx-datepicker .mx-input-wrapper .mx-icon-clear {
  display: none !important;
}

.review[style*="pointer-events: none"] .mx-datepicker .mx-input {
  border: none !important;
  background: transparent !important;
  padding-left: 0 !important;
}

/* 電話輸入框的特殊處理 */
.review[style*="pointer-events: none"] .vue-tel-input {
  border: none !important;
  background: transparent !important;
}

.review[style*="pointer-events: none"] .vue-tel-input .vti__dropdown {
  display: none !important;
}

/* 隱藏文件上傳按鈕和相關元素 */
.review[style*="pointer-events: none"] .req_file {
  display: none !important;
}

/* Select2 特殊處理 - 確保選中的值顯示為藍色文字 */
.review[style*="pointer-events: none"] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #007bff !important;
  padding-left: 0 !important;
}

/* 確保文字對齊 */
.review[style*="pointer-events: none"] .form-group input,
.review[style*="pointer-events: none"] .form-group select {
  line-height: 1.5 !important;
  min-height: auto !important;
}

.review[style*="pointer-events: none"] .language::after {
  display: none !important;
}

.review[style*="pointer-events: none"] .download_sample {
  display: none !important;
}

.review[style*="pointer-events: none"] .phone-control {
  display: none !important;
}

.review[style*="pointer-events: none"] .select2-control {
  display: none !important;
}

/* 為禁用的學歷選擇框添加樣式 */
select.form-control:disabled {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  border-color: #dee2e6 !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}

.review[style*="pointer-events: none"] .mx-datepicker {
  display: none !important;
}

.img_preview {
  width: 50%;
  height: auto;
  margin-top: 5px;
  margin-left: 1px;
}

.show_preview {
  margin-top: 5px;
  color: blue;
  font-weight: 400;
}
</style>
